/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/_build/webpack_bundles/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 626);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO - switch to static class over singleton
var URLs = function () {
    _createClass(URLs, null, [{
        key: 'getInstance',
        value: function getInstance() {
            URLs._instance = URLs._instance || new URLs();
            return URLs._instance;
        }
    }]);

    function URLs() {
        _classCallCheck(this, URLs);

        if (URLs._instance) {
            return URLs._instance;
        }
        URLs._instance = this;

        this.urls = {
            'home': '/',
            'create': this._create,
            'forgot_password': null,
            'gallery': this._gallery,
            'gallery/category': function galleryCategory(data) {
                return '/gallery/category/' + data.category + '/';
            },
            'ajax_gallery_suggestions': function ajax_gallery_suggestions(data) {
                return '/ajax/gallery/suggestions/' + data.search + '/';
            },
            'ajax_gallery_category': function ajax_gallery_category(data) {
                return '/ajax/gallery/' + data.category + '/';
            },
            'ajax_gallery_template': function ajax_gallery_template(data) {
                return '/services/gallery/templates/' + data.template + '/';
            },
            'ajax_gallery_category_featured': function ajax_gallery_category_featured(data) {
                return '/ajax/gallery/' + data.category + '/featured/';
            },
            'ajax_gallery_favorites': function ajax_gallery_favorites() {
                return '/ajax/gallery/favorites/';
            },
            'ajax_event_suggestions': function ajax_event_suggestions(data) {
                return '/ajax/event/suggestions/' + data.search + '/';
            },
            'ajax_event_settings': function ajax_event_settings(data) {
                return '/ajax/event/' + data.event_id + '/view/settings/';
            },
            'ajax_event_guestlist': function ajax_event_guestlist(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/?gid=' + data.gid;
            },
            'ajax_event_avatars': function ajax_event_avatars(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/avatars/?gid=' + data.gid;
            },
            'ajax_edit_guest_tags': function ajax_edit_guest_tags(data) {
                return '/ajax/event/' + data.event_id + '/posts/' + data.post_id + '/tags/?gid=' + data.gid;
            },
            'ajax_render_event_image': function ajax_render_event_image(data) {
                return '/ajax/event/' + data.event_id + '/renderimage/';
            },
            'ajax_event_posts': function ajax_event_posts(data) {
                return '/ajax/event/' + data.event_id + '/posts/?cursor=' + (data.cursor || '') + '&gid=' + data.gid;
            },
            'ajax_event_photos': function ajax_event_photos(data) {
                return '/ajax/event/' + data.event_id + '/posts/photos/?per_page=' + (data.per_page || 10) + '&cursor=' + (data.cursor || '') + '&gid=' + data.gid;
            },
            'ajax_event_guestlist_search': function ajax_event_guestlist_search(data) {
                return '/ajax/event/' + data.event_id + '/guestlist/search/?q=' + data.search_term + '&gid=' + data.gid;
            },
            'login': '/login/',
            'login_modal': '/modal/login/',
            'register_modal': '/modal/register/',
            'recaptcha': '/modal/recaptcha/',
            'sms_captcha': '/modal/sms_captcha/',
            'ad_captcha': '/modal/ad_captcha/',
            'modal_dialog': '/modal/dialog',
            'modal_warning': '/modal/warning',
            'modal_loading': '/modal/loading',
            'modal_ajax_error': '/modal/ajax_error/',
            'import_contacts': '/profile/contacts/import/',
            'ajax_user_status': '/ajax/settings/account/status/',
            'modal_merge_registered': '/modal/settings/account/merge/registered/',
            'modal_merge_secondary': '/modal/settings/account/merge/secondary/',
            'ajax_merge_registered': '/ajax/settings/account/merge/registered/',
            'modal_contacts_edit': '/modal/profile/contacts/edit',
            'modal_contacts_new': '/modal/profile/contacts/new',
            'modal_contacts_groups_edit': '/modal/profile/contacts/groups/edit',
            'modal_contacts_groups_new': '/modal/profile/contacts/groups/new',
            'modal_contacts_add__select_group': '/modal/profile/contacts/groups/select',
            'modal_contacts_add__list': '/modal/profile/contacts/groups/list',
            'modal_recurring_event': '/modal/event/recurring_event/',
            'ajax_event_schedule': function ajax_event_schedule(data) {
                return '/ajax/event/recurring_event/' + data.event_id + '/';
            },
            'ajax_cancel_one_recurring': function ajax_cancel_one_recurring(data) {
                return '/ajax/event/cancel_one_recurring/' + data.event_id + '/';
            },
            'ajax_cancel_all_recurring': function ajax_cancel_all_recurring(data) {
                return '/ajax/event/cancel_all_recurring/' + data.event_id + '/';
            },
            'modal_edit_one_recurring': function modal_edit_one_recurring(data) {
                return '/modal/event/edit_one_recurring/' + data.event_id + '/' + data.old_date + '/';
            },
            'ajax_edit_one_recurring': function ajax_edit_one_recurring(data) {
                return '/ajax/event/edit_one_recurring/' + data.event_id + '/';
            },
            'profile_events': '/profile/events/',
            'more_past_events': '/profile/events/past/more/',
            'ajax_remove_inbox_event': '/ajax/profile/events/remove/',
            'ajax_send_verify_email': '/profile/send_verify_email/',
            'modal_notification_prefs': '/modal/profile/notification/',
            'ajax_profile_contacts': '/ajax/profile/contacts/',
            'ajax_profile_multiple_contacts': '/ajax/profile/contacts/multiple/',
            'ajax_delete_multiple_contacts': '/ajax/profile/contacts/multiple/delete/',
            'ajax_profile_contacts_groups': '/ajax/profile/groups/',
            'ajax_contacts_groups__add_contacts': function ajax_contacts_groups__add_contacts(data) {
                return '/ajax/profile/groups/' + data.group_id + '/add_contacts/';
            },
            'ajax_contacts_groups__remove_contact': function ajax_contacts_groups__remove_contact(data) {
                return '/ajax/profile/groups/' + data.group_id + '/remove/' + data.contact_id + '/';
            },
            'ajax_remove_photo': '/ajax/profile/remove_photo/',
            'register': '/register/',
            'forgot_modal': '/modal/forgot/',
            // 'forgot_mobile': '/mobile/forgot/',
            'cstool_set_spam': function cstool_set_spam(data) {
                return '/cstool/set_spam/' + data.event_id + '/' + data.status + '/' + data.task_name + '/';
            },
            'cstool_edit_admin_user': '/cstool/admin/users/edit/',
            'cstool_edit_permissions': '/cstool/admin/permissions/edit/',
            'cstool_edit_admin_device_versions': '/cstool/admin/device-versions/edit/',
            'cstool_edit_phone_optout': '/cstool/admin/phone_optout/edit/',
            'cstool_spam_mark_as_seen': '/cstool/spam/event/mark_as_seen/',
            'cstool_spam_events': '/cstool/spam/events/',
            'cstool_event_actions': '/cstool/events/ajax_actions/',
            'cstool_user_actions': '/cstool/users/ajax_actions/',
            'cstool_event': '/cstool/events/event/',
            'view': function view(data) {
                return '/event/' + data.event_id + '/';
            },
            'send_message_modal': function send_message_modal(data) {
                return '/event/' + data.event_id + '/view/send_message_modal/';
            },
            'send_sms_modal': function send_sms_modal(data) {
                return '/event/' + data.event_id + '/view/send_sms_modal/';
            },
            'ajax_view_profiles': function ajax_view_profiles(data) {
                return '/ajax/event/' + data.event_id + '/view/profiles/';
            },
            'ajax_view_rsvp': function ajax_view_rsvp(data) {
                return '/ajax/event/' + data.event_id + '/view/rsvp/';
            },
            'modal_knot_link_registry': '/modal/event/link_registry/',
            'modal_knot_find_registry': '/modal/event/find_registry/',
            'ajax_logout': '/ajax_logout',
            'ajax_knot_search': '/ajax/knot_search/',
            'ajax_request_upload_path': '/ajax/upload/prepare',
            'ajax_fetchuyo': '/ajax/images/fetchuyo',
            'ajax_crop_image': function ajax_crop_image(data) {
                return '/ajax/images/' + data.image_id + '/crop';
            },
            'ajax_content_feed': function ajax_content_feed(data) {
                return '/ajax/content/feed/' + data.event_type;
            },
            'main_image': function main_image(data) {
                return '/services/images/' + data.image_id + '/main';
            },
            'large_image': function large_image(data) {
                return '/services/images/' + data.image_id + '/large';
            },
            'image_url': function image_url(data) {
                return '/services/image_url/' + data.image_id + '/' + data.size;
            },
            'image_redirect': function image_redirect(data) {
                return '/services/image_redirect/' + data.image_id + '/' + (data.size || "");
            },
            'ajax_comments': function ajax_comments(data) {
                return '/ajax/event/comments/' + data.event_id + '/' + window.guest_id + '/';
            },
            'modal_add_to_calendar': function modal_add_to_calendar(data) {
                return '/modal/event/' + data.event_id + '/add_to_calendar/';
            },
            'invite_more': this._invite_more,
            'send': '/event/send/',
            'cancel': '/event/cancel/',
            'whatsnext': function whatsnext(data) {
                return '/whatsnext/' + data.event_id + '/';
            },
            'edit': function edit(data) {
                return '/event/' + data.event_id + '/edit/';
            },
            'upload_guest_csv': function upload_guest_csv(data) {
                return '/event/' + data.event_id + '/guests/csv/';
            },
            'ajax_guestlist': function ajax_guestlist(data) {
                return '/ajax/event/' + data.event_id + '/dashboard/guestlist/';
            },
            'event_dashboard': function event_dashboard(data) {
                return '/event/' + data.event_id + '/dashboard/';
            },
            'parse_guest': '/ajax/event/parse_guests/',
            'guest_list_save': function guest_list_save(data) {
                return '/ajax/event/' + data.event_id + '/replace_guests/';
            },
            'guest_list_add': function guest_list_add(data) {
                return '/ajax/event/' + data.event_id + '/add_guests/';
            },
            'frp_updated': function frp_updated(data) {
                return '/event/' + data.event_id + '/frp/updated/';
            },
            'frp_message_sent': function frp_message_sent(data) {
                return '/event/' + data.event_id + '/frp/message_sent/';
            },
            'frp_sent': function frp_sent(data) {
                return '/event/' + data.event_id + '/frp/sent/';
            },
            'frp_saved': function frp_saved(data) {
                return '/event/' + data.event_id + '/frp/saved/';
            },
            'frp_canceled': function frp_canceled(data) {
                return '/event/' + data.event_id + '/frp/canceled/';
            },
            'ajax_preview': '/event/preview/',
            'ajax_authenticated': '/ajax/authenticated/',
            'facebook_connect': '/services/extdata/oa2/login/facebook/login/',
            'google_plus_connect': '/services/extdata/oa2/login/google_plus/login/',
            'set_draft_guests': '/ajax/set_draft_guests/',
            'csv_import_contacts': '/profile/contacts/import/csv/',
            'ajax_subscribe': '/ajax/subscribe/',
            'ajax_send_sms': function ajax_send_sms(data) {
                return '/ajax/event/' + data.event_id + '/send_sms/';
            },
            'event_map': function event_map(data) {
                return '/event/' + data.event_id + '/map?gid=' + data.guest_id;
            },
            'event_map_redirect': function event_map_redirect(data) {
                return '/event/' + data.event_id + '/map_redirect?gid=' + data.guest_id;
            },
            'print_event': function print_event(data) {
                return '/event/' + data.event_id + '/export/print';
            },
            'print_event_premium': function print_event_premium(data) {
                return '/plus/view/' + data.event_id + '/' + data.guest_id + '/print_invitation/?';
            },
            'ajax_notify_items': '/ajax/notify/items',
            'ajax_notify_update': '/ajax/notify/update',
            'all_notifications': '/all-notifications'
        };
    }

    _createClass(URLs, [{
        key: 'get',
        value: function get(name, params) {
            var url = this.urls[name];
            if (!url) {
                throw Error('URL ' + name + ' is not mapped');
            }
            if (typeof url === 'function') {
                var escaped = {};
                if (params) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.keys(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var k = _step.value;

                            var v = params[k];
                            escaped[k] = encodeURIComponent(v);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                url = url(escaped);
            }

            if (/\b(null|undefined)\b/i.test(url)) {
                evite.warn('URLs|Potential issue in parsed url: ' + url);
            }
            return url;
        }
    }, {
        key: '_invite_more',
        value: function _invite_more(params) {
            var event_id = params.eid || params.event_id || window.event_id;
            var p = {
                guest_id: params.gid || window.guest_id
            };
            var param_str = $.param(p);
            return '/event/' + event_id + '/invite_more/?' + param_str;
        }
    }, {
        key: '_create',
        value: function _create(params) {
            var p = {
                template: params.template,
                event_type: params.event_type || params.eventType
            };
            var param_str = $.param(p);
            return '/event/create/?' + param_str;
        }
    }, {
        key: '_profile',
        value: function _profile(params) {
            if (params && params.uid) {
                return '/profile/public/' + params.uid + '/';
            }
            return "/profile/";
        }
    }, {
        key: '_profile_private',
        value: function _profile_private(params) {
            if (params.section) {
                if (params.section === 'events') {
                    if (params.tab === 'upcoming') {
                        return this.get('profile_events');
                    }
                    if (params.tab === 'past') {
                        return this.get('profile_past_events');
                    }
                }
                if (params.section === 'contacts') {
                    return this.get('profile_contacts');
                }
            }

            return this.get('profile_edit');
        }
    }, {
        key: '_account_validate',
        value: function _account_validate(params) {
            var k, p, url, v;
            url = this.get('verify_email');
            p = [];
            for (k in params) {
                v = params[k];
                p.push(k + "=" + v);
            }
            return url + '?' + p.join('&');
        }
    }, {
        key: '_reset_password',
        value: function _reset_password(params) {
            return this.get('reset_password') + ("?token=" + params.chk);
        }
    }, {
        key: '_gallery',
        value: function _gallery(params) {
            if (params) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.keys(params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var k = _step2.value;

                        var v = params[k];
                        params[k] = unescape(v);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var param_str = $.param(params);
            return '/gallery/?' + param_str;
        }
    }]);

    return URLs;
}();

;

exports.default = URLs.getInstance();

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendSMSModal = exports.SendMessageModal = exports.ModalDialog = exports.LoadingModal = exports.ModalAjaxError = exports.ModalWarning = exports.PopupModal = exports.CaptchaDialog = exports.AuthModal = exports.EviteModal = undefined;

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

var _captcha_modal = __webpack_require__(21);

var _captcha_modal2 = _interopRequireDefault(_captcha_modal);

var _popup_modal = __webpack_require__(14);

var _popup_modal2 = _interopRequireDefault(_popup_modal);

var _warning_modal = __webpack_require__(22);

var _warning_modal2 = _interopRequireDefault(_warning_modal);

var _ajax_error_modal = __webpack_require__(23);

var _ajax_error_modal2 = _interopRequireDefault(_ajax_error_modal);

var _loading_modal = __webpack_require__(24);

var _loading_modal2 = _interopRequireDefault(_loading_modal);

var _send_message_modal = __webpack_require__(16);

var _send_message_modal2 = _interopRequireDefault(_send_message_modal);

var _dialog_modal = __webpack_require__(17);

var _dialog_modal2 = _interopRequireDefault(_dialog_modal);

var _auth_modal = __webpack_require__(25);

var _auth_modal2 = _interopRequireDefault(_auth_modal);

var _send_sms_modal = __webpack_require__(20);

var _send_sms_modal2 = _interopRequireDefault(_send_sms_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EviteModal = _evite_modal2.default;
exports.AuthModal = _auth_modal2.default;
exports.CaptchaDialog = _captcha_modal2.default;
exports.PopupModal = _popup_modal2.default;
exports.ModalWarning = _warning_modal2.default;
exports.ModalAjaxError = _ajax_error_modal2.default;
exports.LoadingModal = _loading_modal2.default;
exports.ModalDialog = _dialog_modal2.default;
exports.SendMessageModal = _send_message_modal2.default;
exports.SendSMSModal = _send_sms_modal2.default;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(58),
    isMasked = __webpack_require__(101),
    isObject = __webpack_require__(33),
    toSource = __webpack_require__(103);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(102);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(75),
    isIterateeCall = __webpack_require__(69);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(76);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(108),
    shortOut = __webpack_require__(110);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(109),
    defineProperty = __webpack_require__(57),
    identity = __webpack_require__(59);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(77),
    baseKeysIn = __webpack_require__(121),
    isArrayLike = __webpack_require__(49);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(114),
    isObjectLike = __webpack_require__(29);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    isObjectLike = __webpack_require__(29);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(116);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)(module)))

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(118),
    baseUnary = __webpack_require__(119),
    nodeUtil = __webpack_require__(120);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    isLength = __webpack_require__(60),
    isObjectLike = __webpack_require__(29);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(51);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)(module)))

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33),
    isPrototype = __webpack_require__(79),
    nativeKeysIn = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 122:
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 129:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.show = show;
exports.hide = hide;
exports.toggle = toggle;
exports.appendChild = appendChild;
exports.appendChildren = appendChildren;
exports.removeChildren = removeChildren;
exports.buildScriptTag = buildScriptTag;
exports.addScriptTag = addScriptTag;
exports.remove = remove;
exports.getElementAttributes = getElementAttributes;
exports.createElement = createElement;
exports.mapElementToProps = mapElementToProps;
exports.css = css;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.toggleClass = toggleClass;
exports.scrollTo = scrollTo;
exports.addToLoadingQueue = addToLoadingQueue;
exports.isDomNode = isDomNode;
var evite = window.evite = window.evite || {};

function show(subject) {
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if ('show' in subject) {
    subject.show();
  } else {
    subject.classList.remove('hidden');
  }
}

function hide(subject) {
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if ('hide' in subject) {
    subject.hide();
  } else {
    subject.classList.add('hidden');
  }
}

function toggle(subject) {
  var showElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!subject) {
    return;
  }

  if (arguments.length === 1) {
    if (subject.toggle) {
      subject.toggle();
      return;
    }

    showElement = subject.offsetParent === null;
  }

  if (showElement) {
    show(subject);
  } else {
    hide(subject);
  }
}

function appendChild(subject, child) {
  if (!subject) {
    return;
  }

  if (subject.append) {
    subject.append(child);
  } else {
    subject.appendChild(child);
  }
}

function appendChildren(subject, children) {
  if (!subject) {
    return;
  }

  children = arguments.length === 2 && Array.isArray(children) ? children : Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < children.length; ++i) {
    var childOrArray = children[i];
    if (Array.isArray(childOrArray)) {
      appendChildren(subject, childOrArray);
    } else {
      appendChild(subject, childOrArray);
    }
  }
}

function removeChildren(subject) {
  if (!subject) {
    return;
  }
  if ('removeChildren' in subject) {
    subject.removeChildren();
  } else {
    while (subject.lastChild) {
      subject.removeChild(subject.lastChild);
    }
  }
}

function buildScriptTag(_ref) {
  var src = _ref.src,
      type = _ref.type,
      defer = _ref.defer,
      async = _ref.async,
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      className = _ref.className,
      innerText = _ref.innerText,
      innerHTML = _ref.innerHTML;

  defer = Boolean(defer);
  async = Boolean(async);
  onLoad = onLoad || '';
  onError = onError || '';
  className = className || '';
  innerText = innerText || '';

  var id = evite.guid('script-id');

  var scriptTag = document.createElement('script');
  scriptTag.type = type || 'text/javascript';
  scriptTag.async = async;
  scriptTag.defer = defer;
  scriptTag.className = className;

  scriptTag.addEventListener('load', function () {
    evite.resolve(src);
    onLoad();
  });

  scriptTag.addEventListener('error', function () {
    evite.reject(src);
    onError();
  });
  if (src) {
    scriptTag.src = src;
  } else if (innerHTML) {
    scriptTag.innerHTML = innerHTML;
  } else if (innerText) {
    scriptTag.innerText = innerText;
  }

  return scriptTag;
}

// TODO - refactor
function addScriptTag(_ref2) {
  var src = _ref2.src,
      type = _ref2.type,
      defer = _ref2.defer,
      async = _ref2.async,
      onLoad = _ref2.onLoad,
      onError = _ref2.onError,
      className = _ref2.className;


  evite.when('document.ready').then(function () {
    var scriptTag = buildScriptTag({ src: src, type: type, defer: defer, async: async, onLoad: onLoad, onError: onError, className: className });

    appendChild(document.head, scriptTag);
  });
}

function remove(el) {
  if (el && el.parentElement) {
    el.parentElement.removeChild(el);
  }
}

function getElementAttributes(el) {
  var json = {};
  if (el) {
    Array.from(el.attributes).forEach(function (attribute) {
      json[attribute.name] = attribute.value;
    });
  }
  return json;
}

function createElement(elOrTagNameOrComponent, props) {
  var el = void 0;
  if (typeof elOrTagNameOrComponent === 'string') {
    var elStr = elOrTagNameOrComponent;
    elStr = elStr.trim();

    var div = document.createElement('div');
    div.innerHTML = elStr.trim();
    el = div.firstChild;
  } else if ('render' in elOrTagNameOrComponent) {
    el = elOrTagNameOrComponent.render();
  } else if (typeof elOrTagNameOrComponent === 'function') {
    el = elOrTagNameOrComponent(props);
    props = null;
  } else {
    el = elOrTagNameOrComponent;
  }

  if (props) {
    mapElementToProps(el, props);
  }

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var length = children.length;
  for (var i = 0; i < length; ++i) {
    var child = children[i];
    child = createElement(child);

    appendChild(el, child);
  }

  return el;
}

function mapElementToProps(el, props) {
  if (!el) {
    return null;
  }
  for (var property in props) {
    var value = props[property];
    if ((property === 'styles' || property === 'style') && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      css(el, value);
    } else if (property === 'dangerouslySetInnerHTML') {
      el.innerHTML = value;
    } else if (property === 'classList') {
      var list = void 0;
      if (typeof value === 'string') {
        list = value.split(/\s+/);
      } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && 'forEach' in value) {
        list = value;
      } else {
        list = [value];
      }
      list.forEach(function (className) {
        addClass(el, className);
      });
    } else if (property === 'className') {
      el.setAttribute('class', value);
    } else if (/^on[A-Z]/.test(property) && typeof value === 'function') {
      var eventType = property.replace(/^on/, '').toLowerCase();
      evite.listenTo(el, eventType, value);
    } else {
      el.setAttribute(property, value);
    }
  }

  return el;
}

function css(el, styles) {
  //evite.assert(el, 'Expected element to be non null.');

  if (!el) {
    return;
  }

  if (!styles) {
    el.style.cssText = '';
    return;
  }

  for (var prop in styles) {
    var value = styles[prop];
    if (typeof value === 'number') {
      el.style[prop] = value + 'px';
    } else {
      el.style[prop] = value;
    }
  }
}

function hasClass(el, className) {
  return el && el.classList && el.classList.contains(className) || false;
}

function addClass(el, className) {
  if (el && el.classList) {
    el.classList.add(className);
  }
}

function removeClass(el, className) {
  if (el && el.classList) {
    el.classList.remove(className);
  }
}

function toggleClass(el, className, add) {
  if (arguments.length === 2) {
    add = !hasClass(el, className);
  }

  if (add) {
    addClass(el, className);
  } else {
    removeClass(el, className);
  }
}

/**
 * Scroll to an element on the page
 *
 * modified from https://stackoverflow.com/questions/17722497/scroll-smoothly-to-specific-element-on-page
 * https://jsfiddle.net/s61x7c4e/
 *
 * @param element dom element
 * @param duration
 * @param marginTop additional header room for fixed elements, or if you want to scroll above `element`
 */
function scrollTo(element, duration) {
  var marginTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var startingY = window.pageYOffset;
  var elementY = window.pageYOffset + element.getBoundingClientRect().top - marginTop;
  // If element is close to page's bottom then window will scroll only to some position above the element.
  var tooClose = document.body.scrollHeight - elementY < window.innerHeight;
  var targetY = tooClose ? document.body.scrollHeight - window.innerHeight : elementY;
  var diff = targetY - startingY;
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  function easing(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }
  var start = void 0;

  if (!diff) return;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) window.requestAnimationFrame(step);
  });
}

var idleLoadingQueue = [];
var loadingInProgress = void 0;
function addToLoadingQueue(_ref3) {
  var url = _ref3.url,
      priority = _ref3.priority;

  evite.when('window.load').then(function () {
    priority = priority || 0;
    if (url) {
      idleLoadingQueue.splice(priority, 0, url);
      if (!loadingInProgress) {
        evite.requestIdleCallback(loadNextInQueue);
      }
    }
  });

  return evite.when(url);
}

function loadNextInQueue() {
  if (!loadingInProgress && idleLoadingQueue.length) {
    loadingInProgress = true;

    var url = idleLoadingQueue.pop();

    var isImage = /\.(jpeg|jpg|gif|png)\b/i.test(url);
    if (isImage) {
      var image = new Image();
      var completeHandler = handleQueueLoadComplete.bind(null, url, image);
      image.addEventListener('load', completeHandler);
      image.addEventListener('error', completeHandler);
      image.src = url;
      return;
    }

    var isCss = /\.(css)\b/i.test(url);
    if (isCss) {
      var link = evite.dom.createElement('<link rel="stylesheet" media="none"/>', { href: url });
      var _completeHandler = handleQueueLoadComplete.bind(null, url, link);
      link.addEventListener('load', _completeHandler);
      link.addEventListener('error', _completeHandler);
      document.body.appendChild(link);
      return;
    }

    handleQueueLoadComplete();
  }
}

function handleQueueLoadComplete(url, value) {
  loadingInProgress = false;
  if (url) {
    evite.resolve(url, value);
  }

  evite.requestIdleCallback(loadNextInQueue);
}

function isDomNode(o) {
  if (!o) {
    return false;
  }
  return window.HTMLElement && o instanceof HTMLElement || o.nodeType === 1 && typeof o.nodeName === 'string';
}

Object.assign(evite, exports);

evite.dom = evite.dom || {};
Object.assign(evite.dom, exports);

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    getPrototype = __webpack_require__(137),
    isObjectLike = __webpack_require__(29);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(92);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupModal = undefined;

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupModal = exports.PopupModal = function PopupModal(settings) {
  _classCallCheck(this, PopupModal);

  this.settings = {
    buttons: ['Cancel', 'Yes'],
    html: false,
    title: null,
    body: '',
    width: "480px",
    popup: true
  };

  return new _evite_modal2.default(Object.assign({}, this.settings, settings));
};

exports.default = PopupModal;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(18);
var v4 = __webpack_require__(19);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    isObjectLike = __webpack_require__(29),
    isPlainObject = __webpack_require__(136);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),

/***/ 156:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 157:
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(255);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SendMessageModal = function SendMessageModal(settings) {
    _classCallCheck(this, SendMessageModal);

    this.settings = {
        clickOutside: false,
        allowClose: false,
        width: '800px',
        title: 'Send a Message',
        cancel: 'Cancel',
        subject: 'Message about {subject}',
        message: '',
        guests: []
    };

    this.settings = _extends({}, this.settings, settings);
    this.settings.url_parameters = {
        subject: this.settings.subject,
        message: this.settings.message,
        title: this.settings.title,
        cancel: this.settings.cancel,
        template: this.settings.template
    };
    this.settings.url = _urls2.default.get('send_message_modal', { event_id: settings.event_id || window.event_id });
    return new _evite_modal2.default(this.settings);
};

exports.default = SendMessageModal;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(1);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Example simple usage:
//
//  delete_modal = new ModalDialog
//    title:      'Delete Group'
//    body:       'Are you sure you wish to delete this group?'
//    buttons:    ['Cancel', 'Delete Group']
//    onResponse: (response) ->
//      if response.index == 1
//        console.log 'delete group'
//  delete_modal.show()

var ModalDialog = function ModalDialog(settings) {
  _classCallCheck(this, ModalDialog);

  this.settings = {
    url: _urls2.default.get('modal_dialog'),
    buttons: ['Cancel', 'Yes'],
    title: null,
    html: false,
    width: "480px",
    dialog: {}
  };

  if (!this.settings.url_parameters) {
    this.settings.url_parameters = {};
  }
  this.settings.url_parameters.dialog = {
    body: settings.body || '',
    title: settings.title || this.settings.title,
    buttons: settings.buttons || this.settings.buttons,
    html: settings.html || this.settings.html
  };
  return new _index.EviteModal(Object.assign({}, this.settings, settings));
};

exports.default = ModalDialog;

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    isObjectLike = __webpack_require__(29);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(8);
var bytesToUuid = __webpack_require__(9);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

var assignInWith = __webpack_require__(243),
    attempt = __webpack_require__(244),
    baseValues = __webpack_require__(245),
    customDefaultsAssignIn = __webpack_require__(246),
    escapeStringChar = __webpack_require__(247),
    isError = __webpack_require__(155),
    isIterateeCall = __webpack_require__(69),
    keys = __webpack_require__(248),
    reInterpolate = __webpack_require__(157),
    templateSettings = __webpack_require__(251),
    toString = __webpack_require__(158);

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, customDefaultsAssignIn);

  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

module.exports = template;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cookie;
/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Set the value of a cookie.
 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * @desc Create a cookie with all available options.
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Create a session cookie.
 * @example $.cookie('the_cookie', null);
 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *       used when the cookie was set.
 *
 * @param String name The name of the cookie.
 * @param String value The value of the cookie.
 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
 *                             when the the browser exits.
 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *                        require a secure protocol (like HTTPS).
 * @type undefined
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 *
 * @example $.cookie('the_cookie');
 * @desc Get the value of a cookie.
 *
 * @param String name The name of the cookie.
 * @return The value of the cookie.
 * @type String
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */
function cookie(name, value, options) {
    if (typeof value != 'undefined') {
        // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else {
        // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == name + '=') {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

window.evite = window.evite || {};
window.evite.cookie = cookie;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO - remove Backbone Event extension
var Timer = function () {
  function Timer() {
    var _this = this;

    var milliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    var numTicks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, Timer);

    this.handleInterval = function () {
      _this.startTime = Date.now();
      _this.currentTick++;
      _this.trigger(Timer.TICK);

      if (_this.isDone) {
        _this.pause();
        _this.trigger(Timer.COMPLETE);
      }
    };

    this.millisecondsOffset = 0;
    this.milliseconds = milliseconds;
    this.currentTick = 0;
    this.numTicks = numTicks;
    this.handleInterval = this.handleInterval;
  }

  _createClass(Timer, [{
    key: "start",
    value: function start() {
      var newDelay = this.millisecondsOffset + this.milliseconds;

      if (!this.isRunning && !this.isDone && newDelay > 0) {
        this.startTime = Date.now();
        this.intervalId = setInterval(this.handleInterval, newDelay);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.isRunning) {
        clearInterval(this.intervalId);
        this.intervalId = 0;
        this.millisecondsOffset = this.startTime - Date.now();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.pause();
      this.currentTick = 0;
      this.millisecondsOffset = 0;
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.start();
    }
  }, {
    key: "isDone",
    get: function get() {
      return this.currentTick >= this.numTicks;
    }
  }, {
    key: "isRunning",
    get: function get() {
      return Boolean(this.intervalId);
    }
  }]);

  return Timer;
}();

exports.default = Timer;


Timer.TICK = "TICK";
Timer.COMPLETE = "COMPLETE";

// TODO - switch to emitter
_.extend(Timer.prototype, Backbone.Events);

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(8);
var bytesToUuid = __webpack_require__(9);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _base = __webpack_require__(7);

var _base2 = _interopRequireDefault(_base);

var _dom = __webpack_require__(13);

var _utils = __webpack_require__(5);

var _uuid = __webpack_require__(15);

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EviteModal = (_temp = _class = function () {
    function EviteModal(settings) {
        _classCallCheck(this, EviteModal);

        _initialiseProps.call(this);

        this.settings = _extends({}, this.defaults, settings);
        this.id = _uuid2.default.v1();
        this.modal = _base2.default.getInstance();
        this.parser = this.modal.parser;
        this.buildContainer();
    }

    _createClass(EviteModal, [{
        key: 'buildContainer',
        value: function buildContainer() {
            this.target = (0, _utils.htmlFromString)('<div id="eviteModal-' + this.id + '" class="eviteModalContentOuter"><div class="eviteModalContainer"><div class="eviteModalContent"></div></div></div>');
            this.target.querySelector('.eviteModalContainer').style.cssText = '\n            background: white;\n            max-width: ' + this.settings.width + ';\n            border: 1px solid #A8A8A8;\n            border-radius: 6px;\n            overflow: hidden;';
        }
    }, {
        key: 'encodeUrlParams',
        value: function encodeUrlParams(data) {
            var ret = [];
            for (var d in data) {
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            }return ret.join('&');
        }
    }, {
        key: '_query_string',
        value: function _query_string() {
            var params = {
                p: JSON.stringify(this.settings.url_parameters),
                parent_url: document.location.href
            };
            return '?' + this.encodeUrlParams(params);
        }
    }, {
        key: 'buildPopup',
        value: function buildPopup() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                if (!_this.settings.body) {
                    reject('"body" is required');
                }
                if (!_this.settings.title) {
                    reject('"title" is required');
                }
                if (!_this.settings.buttons) {
                    reject('"buttons" is required');
                }
                var buttons = _this.settings.buttons;
                var button_markup = '';
                for (var key in buttons) {
                    var button = buttons[key];
                    if (buttons.length === 1 * key + 1) {
                        button_markup += '<a class="button-primary" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    } else {
                        button_markup += '<a class="button-primary-inverse" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    }
                }
                var modalContent = void 0;
                if (_this.settings.parse) {
                    modalContent = '<p>' + _this.settings.body + '</p>';
                }
                var container = _this.target.querySelector('.eviteModalContent');
                container.innerHTML = '\n                <div class=\'popup-modal\'>\n                    <div class="modal-header">\n                        <h1>' + _this.settings.title + '</h1>\n                    </div>\n                    <div class="modal-body">\n                        <div class="wrapper">' + (modalContent || '') + '</div>\n                    </div>\n                    <div class="modal-footer">' + button_markup + '</div>\n                </div>\n            ';

                if (!_this.settings.parse) {
                    container.querySelector('.wrapper').appendChild(_this.settings.body);
                }

                var self = _this;
                function respondToPopup(e) {
                    self.close();
                    if (self.settings.onResponse) self.settings.onResponse.apply(self, [e, self]);
                }

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(_this.settings.buttons)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _key = _step.value;

                        container.querySelectorAll('.modal-footer a')[_key].addEventListener('click', respondToPopup);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                resolve(true);
            });
        }
    }, {
        key: 'buildRemote',
        value: function buildRemote() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.fetchContent().then(function (text) {
                    return _this2.parseContent(text);
                }).then(function (page) {
                    return _this2.injectContent(page);
                }).then(_this2.parseDependencies).then(resolve).catch(function (msg) {
                    return reject(msg);
                });
            });
        }
    }, {
        key: 'show',
        value: function show(htmlResponse) {
            var _this3 = this;

            document.querySelector('body').appendChild(this.target);
            this.modal.initialize(this);
            if (htmlResponse && !this.settings.popup) {
                this.buildFromResponse(htmlResponse);
                this.modal.open('#eviteModal-' + this.id);
                this.open = true;
                return;
            }
            if (this.settings.popup) {
                this.buildPopup().then(function () {
                    _this3.modal.open('#eviteModal-' + _this3.id);
                    _this3.open = true;
                });
            } else {
                this.buildRemote().then(function () {
                    _this3.modal.open('#eviteModal-' + _this3.id);
                    _this3.open = true;
                });
            }
        }
    }]);

    return EviteModal;
}(), _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.target = null;
    this.modalHead = null;
    this.modalBody = null;
    this.parser = null;
    this.open = false;
    this.id = null;
    this.defaults = {
        popup: false,
        width: "480px",
        parse: true
    };

    this.fetchContent = function () {
        var url = _this4.settings.url;
        url += _this4.settings.url_parameters ? _this4._query_string() : '';
        return new Promise(function (resolve, reject) {
            window.evite.fetch(url, {
                method: 'get',
                credentials: "same-origin",
                cache: 'no-cache'
            }).then(function (response) {
                resolve(response.text());
            }).catch(function (message) {
                reject(message);
            });
        });
    };

    this.parseContent = function (text) {
        return _this4.parser.parseFromString(text, "text/html");
    };

    this.injectContent = function (page) {
        _this4.modalHead = page.head;
        _this4.modalBody = page.body.innerHTML;
        _this4.target.querySelector('.eviteModalContent').innerHTML = _this4.modalBody;
        return _this4;
    };

    this.showLoader = function () {
        _this4.loader = document.querySelector('.insideLoader');
        _this4.loader.style.display = 'block';
    };

    this.hideLoader = function () {
        _this4.loader = document.querySelector('.insideLoader');
        _this4.loader.style.display = 'none';
    };

    this.parseDependencies = function () {
        var scripts = Array.from(_this4.modalHead.querySelectorAll('script'));
        var links = Array.from(_this4.modalHead.querySelectorAll('link'));
        var styles = links.filter(function (link) {
            return link.type === "text/css";
        });
        styles.forEach(function (style) {
            style.className = 'eviteModalStyle';
            document.head.appendChild(style);
        });
        scripts.forEach(function (script) {
            var scriptTag = void 0;
            var src = script.getAttribute('src');
            if (src) {
                scriptTag = (0, _dom.buildScriptTag)({
                    src: src,
                    type: 'text/javascript',
                    async: true,
                    className: 'eviteModalScript',
                    onLoad: function onLoad() {
                        return false;
                    }
                });
            } else {
                scriptTag = (0, _dom.buildScriptTag)({
                    type: 'text/javascript',
                    innerHTML: script.innerHTML,
                    className: 'eviteModalScript',
                    onLoad: function onLoad() {
                        return false;
                    }
                });
            }
            document.head.appendChild(scriptTag);
        });
        return _this4;
    };

    this.buildFromResponse = function (serverResponse) {
        var page = _this4.parseContent(serverResponse);
        _this4.injectContent(page);
        _this4.parseDependencies();
    };

    this.close = function () {
        return new Promise(function (resolve, reject) {
            if (_this4.open) {
                _this4.modal.close().then(function () {
                    _this4.open = false;
                    var modalDom = document.getElementById('eviteModal-' + _this4.id);
                    var styles = document.querySelectorAll('.eviteModalStyle');
                    var scripts = document.querySelectorAll('.eviteModalScript');
                    Array.from(styles).forEach(function (el) {
                        return el.parentNode.removeChild(el);
                    });
                    Array.from(scripts).forEach(function (el) {
                        return el.parentNode.removeChild(el);
                    });
                    if (modalDom) modalDom.parentNode.removeChild(modalDom);
                    resolve();
                });
            }
        });
    };

    this.respond = function (options, settings) {
        _this4.modal.respond(options, settings);
    };
}, _temp);
exports.default = EviteModal;

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(1);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SendSMSModal = function SendSMSModal(settings) {
    _classCallCheck(this, SendSMSModal);

    this.settings = {
        guest_id: '',
        phone: '',
        not_you_flow: true,
        url: _urls2.default.get('send_sms_modal', {
            event_id: window.event_id
        })
    };

    this.settings.url_parameters = {
        guest_id: this.settings.guest_id,
        phone: this.settings.phone,
        not_you_flow: this.settings.not_you_flow
    };
    return new _index.EviteModal(Object.assign({}, this.settings, settings));
};

;

exports.default = SendSMSModal;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CaptchaDialog = function CaptchaDialog(settings) {
  _classCallCheck(this, CaptchaDialog);

  this.settings = _extends({
    width: '520px'
  }, settings);
  if (this.settings.challenge.type === 'sms') {
    this.settings.url = _urls2.default.get('sms_captcha');
  } else if (this.settings.challenge.type === 'ad') {
    this.settings.url = _urls2.default.get('ad_captcha');
  } else {
    this.settings.url = _urls2.default.get('recaptcha');
  }
  if (this.settings.challenge.captcha_event) {
    this.settings.url = this.settings.url + this.settings.challenge.captcha_event + '/';
    if (this.settings.challenge.retry) {
      this.settings.url = this.settings.url + 'retry/';
    }
  }
  this.settings.url_parameters = {
    challenge: this.settings.challenge
  };
  return new _evite_modal2.default(this.settings);
};

exports.default = CaptchaDialog;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(1);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalWarning = function ModalWarning(settings) {
  _classCallCheck(this, ModalWarning);

  this.settings = {
    url: _urls2.default.get('modal_warning'),
    buttons: ['Okay'],
    title: null,
    html: false,
    width: "480px",
    dialog: {},
    url_parameters: {}
  };

  this.settings = Object.assign({}, this.settings, settings);
  this.settings.url_parameters.dialog = {
    body: settings.body || '',
    title: settings.title || this.settings.title,
    buttons: settings.buttons || this.settings.buttons,
    html: settings.html || this.settings.html
  };

  return new _index.EviteModal(this.settings);
};

exports.default = ModalWarning;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalAjaxError = undefined;

var _index = __webpack_require__(1);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalAjaxError = exports.ModalAjaxError = function ModalAjaxError(settings) {
  _classCallCheck(this, ModalAjaxError);

  this.settings = {
    url: _urls2.default.get('modal_ajax_error'),
    buttons: ['Okay'],
    title: null,
    html: false,
    width: "480px",
    dialog: {},
    url_parameters: {}
  };

  this.settings = Object.assign({}, this.settings, settings);
  this.settings.url_parameters.dialog = {
    body: settings.body || '',
    title: settings.title || this.settings.title,
    buttons: settings.buttons || this.settings.buttons,
    html: settings.html || this.settings.html
  };

  return new _index.EviteModal(this.settings);
};

exports.default = ModalAjaxError;

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Description:
// An adskin (aka takeover) is a combination of a top ad unit with a background wallpaper
// Usually found on certain category pages and logged in/out homepages

// Mechanics:
// Whether a page has an adskin or not is defined in DFP (DoubleClick for Publishers)
// A top ad loads with a js payload > the payload contains an onloaded callback > the callback calls our adskin function
// An example payload with a callback to our adskin func looks like this:
// https://gist.github.com/benpink/3ca5f9d36949469c0d42

var AdSkin = function () {
    function AdSkin(bgImg, clkPth, trkPth, bgColor) {
        _classCallCheck(this, AdSkin);

        this.render(bgImg, bgColor);
    }

    _createClass(AdSkin, [{
        key: 'render',
        value: function render(bgImg, bgColor) {
            var el = document.body;

            el.className += ' show-adskin box-well';
            el.style.backgroundImage = 'url(' + bgImg + ')';

            if (bgColor) {
                el.style.backgroundColor = bgColor;
            }

            // This is required to move the skin position down when we render a subnav
            if (document.getElementById('gallery-nav')) {
                el.className += ' has-subnav';
            }
        }
    }]);

    return AdSkin;
}();

;

exports.default = AdSkin;

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(store) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PartnerIntegration = exports.PartnerIntegration = function () {
    function PartnerIntegration() {
        var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, PartnerIntegration);

        this.attributes = {
            event_type: null,
            nm: null,
            add: null,
            ct: null,
            st: null,
            zip: null,
            sdt: null,
            edt: null,
            tz: null,
            hn: null,
            et: null,
            ph: null,
            mess: null,
            mess_link: null
        };
        this.save = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(this.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var k = _step.value;

                var passed = values[k] || getURLParameter(k);
                this.attributes[k] = passed;
                if (k !== 'event_type' && passed) {
                    this.save = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (this.save) {
            store.set("partner_ev", this.attributes, {
                TTL: 600000
            });
        }
    }

    _createClass(PartnerIntegration, [{
        key: "fetch",
        value: function fetch() {
            var data;
            data = store.get("partner_ev");
            store.remove("partner_ev");
            return data;
        }
    }]);

    return PartnerIntegration;
}();

exports.default = PartnerIntegration;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(5);

var _base = __webpack_require__(7);

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingModal = function LoadingModal(settings) {
  var _this = this;

  _classCallCheck(this, LoadingModal);

  this.loadingModalDefaults = {
    allowClose: false,
    clickOutside: false,
    width: '420px'
  };
  this.open = false;

  this.close = function () {
    if (_this.open) {
      _this.open = false;
      var modalDom = document.getElementById('loadingModal');
      if (modalDom) {
        // Use this instead of remove for ie11 support
        modalDom.parentNode.removeChild(modalDom);
      }
    }
    return _base2.default.getInstance().close();
  };

  this.show = function (message) {
    document.querySelector('body').appendChild(_this.target);
    var modal = _base2.default.getInstance();
    modal.initialize(_this);
    if (message) _this.target.querySelector('.loader').innerHTML = message;
    modal.open('#loadingModal');
    _this.open = true;
  };

  this.settings = _extends({}, this.settings, this.loadingModalDefaults, settings);
  var contents = (0, _utils.htmlFromString)('<div id="loadingModal" class="eviteModalContent"><div class="loadingContainer"><div class="loader">Loading...</div></div></div>');
  contents.querySelector('.loadingContainer').style.cssText = '\n      background: white;\n      width: ' + this.settings.width + ';\n      height: 233px;\n      border: 1px solid #A8A8A8;\n      border-radius: 6px;\n      overflow: hidden;';

  this.target = contents;
  return this;
};

exports.default = LoadingModal;

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(97),
    createAssigner = __webpack_require__(105),
    keysIn = __webpack_require__(111);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(76),
    baseRest = __webpack_require__(75),
    isError = __webpack_require__(155);

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

module.exports = attempt;


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(156);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(48);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;


/***/ }),

/***/ 247:
/***/ (function(module, exports) {

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

module.exports = escapeStringChar;


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(77),
    baseKeys = __webpack_require__(249),
    isArrayLike = __webpack_require__(49);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(79),
    nativeKeys = __webpack_require__(250);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthModal = function AuthModal(settings) {
    _classCallCheck(this, AuthModal);

    this.settings = {
        clickOutside: true,
        width: '460px',
        title: null,
        url: _urls2.default.get('login_modal')
    };

    this.settings = _extends({}, this.settings, settings);
    return new _evite_modal2.default(this.settings);
};

exports.default = AuthModal;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(92);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(252),
    reEscape = __webpack_require__(256),
    reEvaluate = __webpack_require__(257),
    reInterpolate = __webpack_require__(157);

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

module.exports = templateSettings;


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

var escapeHtmlChar = __webpack_require__(253),
    toString = __webpack_require__(158);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(254);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44),
    arrayMap = __webpack_require__(156),
    isArray = __webpack_require__(78),
    isSymbol = __webpack_require__(177);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44),
    getRawTag = __webpack_require__(80),
    objectToString = __webpack_require__(81);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 29:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__(74);

var _evite = __webpack_require__(40);

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var indexes = {};

var Collection = (_class = function () {
  function Collection() {
    var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { model: null };

    _classCallCheck(this, Collection);

    _initDefineProp(this, 'models', _descriptor, this);

    models = models || [];
    options = options || {};

    if (!this.model && options.model) {
      this.model = options.model;
    }

    this.reset(models, options);
  }

  _createClass(Collection, [{
    key: 'parse',
    value: function parse(list) {
      var Model = this.model;
      list = list || [];
      var length = list.length;

      var modelList = [];

      for (var i = 0; i < length; ++i) {
        var data = list[i];
        var isModel = data instanceof Model;
        var model = isModel ? data : new Model((0, _evite.toJSON)(data));
        modelList.push(model);
      }

      return modelList;
    }
  }, {
    key: 'reset',
    value: function reset(list) {
      if (list && list.length) {
        var newModels = this.parse(list);
        this.replace(newModels);
      } else {
        this.replace([]);
      }
    }
  }, {
    key: 'append',
    value: function append(list) {
      list = Array.isArray(list) ? list : Array.from(arguments);
      this.models.push.apply(this.models, list);
    }
  }, {
    key: 'findWhere',
    value: function findWhere(props) {
      var index = this.findIndexWhere(props);
      if (index === -1) {
        return null;
      }

      return this.models[index];
    }
  }, {
    key: 'findIndexWhere',
    value: function findIndexWhere(props) {
      var modelList = this.models;
      for (var i = 0; i < modelList.length; ++i) {
        var model = modelList[i];
        var isMatch = true;
        for (var key in props) {
          if (props[key] !== model[key]) {
            isMatch = false;
            break;
          }
        }

        if (isMatch) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return (0, _evite.toJSON)(this.models);
    }
  }, {
    key: 'length',
    get: function get() {
      return this.models.length;
    }
  }]);

  return Collection;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'models', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'append', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'append'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'length', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'length'), _class.prototype)), _class);
exports.default = Collection;
;

['clear', 'concat', 'every', 'filter', 'find', 'findIndex', 'forEach', 'get', 'indexOf', 'intercept', 'join', 'lastIndexOf', 'map', 'move', 'peek', 'observe', 'peek', 'pop', 'push', 'reduce', 'reduceRight', 'remove', 'replace', 'reverse', 'shift', 'slice', 'some', 'sort', 'splice', 'spliceWithArray', 'unshift'].forEach(function (key) {
  if (Collection.prototype[key]) {
    return;
  }

  Collection.prototype[key] = (0, _mobx.action)(key, function () {
    var args = Array.from(arguments);
    return this.models[key].apply(this.models, args);
  });
});

for (var i = 0; i < 1000; ++i) {
  indexes[i] = undefined;
  (function (index) {
    Object.defineProperty(Collection.prototype, index, {
      get: function get() {
        return this.models[index];
      },
      set: (0, _mobx.action)(function (value) {
        this.models[index] = value;
      })
    });
  })(i);
}

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(51);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = evite;

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(XDate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeSinceUTCDate = undefined;

var _utils = __webpack_require__(5);

/*
    Given a UTC timestamp for a time in the past,
    return a human-readable label describing how long ago that was.
 */
function getTimeSinceUTCDate(utc_timestamp) {
  var diffMinutes = utc_timestamp.diffMinutes(XDate());

  var i = Math.floor(diffMinutes / 8640); // 6 days
  if (i >= 1) return utc_timestamp.toString("MMMM d, yyyy");
  i = Math.floor(diffMinutes / 1440); // Days
  if (i >= 1) return (0, _utils.pluralize)("day", i) + " ago";
  i = Math.floor(diffMinutes / 60); // Hours
  if (i >= 1) return (0, _utils.pluralize)("hour", i) + " ago";
  i = Math.floor(diffMinutes); // Minutes
  if (i >= 1) return (0, _utils.pluralize)("minute", i) + " ago";
  return 'just now';
}

exports.getTimeSinceUTCDate = getTimeSinceUTCDate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @preserve XDate v@VERSION
 * Docs & Licensing: http://arshaw.com/xdate/
 */

/*
 * Internal Architecture
 * ---------------------
 * An XDate wraps a native Date. The native Date is stored in the '0' property of the object.
 * UTC-mode is determined by whether the internal native Date's toString method is set to
 * Date.prototype.toUTCString (see getUTCMode).
 *
 */

var XDate = (function(Date, Math, Array, undefined) {


/** @const */ var FULLYEAR     = 0;
/** @const */ var MONTH        = 1;
/** @const */ var DATE         = 2;
/** @const */ var HOURS        = 3;
/** @const */ var MINUTES      = 4;
/** @const */ var SECONDS      = 5;
/** @const */ var MILLISECONDS = 6;
/** @const */ var DAY          = 7;
/** @const */ var YEAR         = 8;
/** @const */ var WEEK         = 9;
/** @const */ var DAY_MS = 86400000;
var ISO_FORMAT_STRING = "yyyy-MM-dd'T'HH:mm:ss(.fff)";
var ISO_FORMAT_STRING_TZ = ISO_FORMAT_STRING + "zzz";


var methodSubjects = [
	'FullYear',     // 0
	'Month',        // 1
	'Date',         // 2
	'Hours',        // 3
	'Minutes',      // 4
	'Seconds',      // 5
	'Milliseconds', // 6
	'Day',          // 7
	'Year'          // 8
];
var subjectPlurals = [
	'Years',        // 0
	'Months',       // 1
	'Days'          // 2
];
var unitsWithin = [
	12,   // months in year
	31,   // days in month (sort of)
	24,   // hours in day
	60,   // minutes in hour
	60,   // seconds in minute
	1000, // milliseconds in second
	1     //
];
var formatStringRE = new RegExp(
	"(([a-zA-Z])\\2*)|" + // 1, 2
	"(\\(" + "(('.*?'|\\(.*?\\)|.)*?)" + "\\))|" + // 3, 4, 5 (allows for 1 level of inner quotes or parens)
	"('(.*?)')" // 6, 7
);
var UTC = Date.UTC;
var toUTCString = Date.prototype.toUTCString;
var proto = XDate.prototype;



// This makes an XDate look pretty in Firebug and Web Inspector.
// It makes an XDate seem array-like, and displays [ <internal-date>.toString() ]
proto.length = 1;
proto.splice = Array.prototype.splice;




/* Constructor
---------------------------------------------------------------------------------*/

// TODO: in future, I'd change signature for the constructor regarding the `true` utc-mode param. ~ashaw
//   I'd move the boolean to be the *first* argument. Still optional. Seems cleaner.
//   I'd remove it from the `xdate`, `nativeDate`, and `milliseconds` constructors.
//      (because you can simply call .setUTCMode(true) after)
//   And I'd only leave it for the y/m/d/h/m/s/m and `dateString` constructors
//      (because those are the only constructors that need it for DST-gap data-loss reasons)
//   Should do this for 1.0

function XDate() {
	return init(
		(this instanceof XDate) ? this : new XDate(),
		arguments
	);
}


function init(xdate, args) {
	var len = args.length;
	var utcMode;
	if (isBoolean(args[len-1])) {
		utcMode = args[--len];
		args = slice(args, 0, len);
	}
	if (!len) {
		xdate[0] = new Date();
	}
	else if (len == 1) {
		var arg = args[0];
		if (arg instanceof Date) {
			xdate[0] = new Date(arg.getTime());
		}
		else if (isNumber(arg)) {
			xdate[0] = new Date(arg);
		}
		else if (arg instanceof XDate) {
			xdate[0] = _clone(arg);
		}
		else if (isString(arg)) {
			xdate[0] = new Date(0);
			xdate = parse(arg, utcMode || false, xdate);
		}
	}
	else {
		xdate[0] = new Date(UTC.apply(Date, args));
		if (!utcMode) {
			xdate[0] = coerceToLocal(xdate[0]);
		}
	}
	if (isBoolean(utcMode)) {
		setUTCMode(xdate, utcMode);
	}
	return xdate;
}



/* UTC Mode Methods
---------------------------------------------------------------------------------*/


proto.getUTCMode = methodize(getUTCMode);
function getUTCMode(xdate) {
	return xdate[0].toString === toUTCString;
};


proto.setUTCMode = methodize(setUTCMode);
function setUTCMode(xdate, utcMode, doCoercion) {
	if (utcMode) {
		if (!getUTCMode(xdate)) {
			if (doCoercion) {
				xdate[0] = coerceToUTC(xdate[0]);
			}
			xdate[0].toString = toUTCString;
		}
	}else{
		if (getUTCMode(xdate)) {
			if (doCoercion) {
				xdate[0] = coerceToLocal(xdate[0]);
			}else{
				xdate[0] = new Date(xdate[0].getTime());
			}
			// toString will have been cleared
		}
	}
	return xdate; // for chaining
}


proto.getTimezoneOffset = function() {
	if (getUTCMode(this)) {
		return 0;
	}else{
		return this[0].getTimezoneOffset();
	}
};



/* get / set / add / diff Methods (except for week-related)
---------------------------------------------------------------------------------*/


each(methodSubjects, function(subject, fieldIndex) {

	proto['get' + subject] = function() {
		return _getField(this[0], getUTCMode(this), fieldIndex);
	};

	if (fieldIndex != YEAR) { // because there is no getUTCYear

		proto['getUTC' + subject] = function() {
			return _getField(this[0], true, fieldIndex);
		};

	}

	if (fieldIndex != DAY) { // because there is no setDay or setUTCDay
	                         // and the add* and diff* methods use DATE instead

		proto['set' + subject] = function(value) {
			_set(this, fieldIndex, value, arguments, getUTCMode(this));
			return this; // for chaining
		};

		if (fieldIndex != YEAR) { // because there is no setUTCYear
		                          // and the add* and diff* methods use FULLYEAR instead

			proto['setUTC' + subject] = function(value) {
				_set(this, fieldIndex, value, arguments, true);
				return this; // for chaining
			};

			proto['add' + (subjectPlurals[fieldIndex] || subject)] = function(delta, preventOverflow) {
				_add(this, fieldIndex, delta, preventOverflow);
				return this; // for chaining
			};

			proto['diff' + (subjectPlurals[fieldIndex] || subject)] = function(otherDate) {
				return _diff(this, otherDate, fieldIndex);
			};

		}

	}

});


function _set(xdate, fieldIndex, value, args, useUTC) {
	var getField = curry(_getField, xdate[0], useUTC);
	var setField = curry(_setField, xdate[0], useUTC);
	var expectedMonth;
	var preventOverflow = false;
	if (args.length == 2 && isBoolean(args[1])) {
		preventOverflow = args[1];
		args = [ value ];
	}
	if (fieldIndex == MONTH) {
		expectedMonth = (value % 12 + 12) % 12;
	}else{
		expectedMonth = getField(MONTH);
	}
	setField(fieldIndex, args);
	if (preventOverflow && getField(MONTH) != expectedMonth) {
		setField(MONTH, [ getField(MONTH) - 1 ]);
		setField(DATE, [ getDaysInMonth(getField(FULLYEAR), getField(MONTH)) ]);
	}
}


function _add(xdate, fieldIndex, delta, preventOverflow) {
	delta = Number(delta);
	var intDelta = Math.floor(delta);
	xdate['set' + methodSubjects[fieldIndex]](
		xdate['get' + methodSubjects[fieldIndex]]() + intDelta,
		preventOverflow || false
	);
	if (intDelta != delta && fieldIndex < MILLISECONDS) {
		_add(xdate, fieldIndex+1, (delta-intDelta)*unitsWithin[fieldIndex], preventOverflow);
	}
}


function _diff(xdate1, xdate2, fieldIndex) { // fieldIndex=FULLYEAR is for years, fieldIndex=DATE is for days
	xdate1 = xdate1.clone().setUTCMode(true, true);
	xdate2 = XDate(xdate2).setUTCMode(true, true);
	var v = 0;
	if (fieldIndex == FULLYEAR || fieldIndex == MONTH) {
		for (var i=MILLISECONDS, methodName; i>=fieldIndex; i--) {
			v /= unitsWithin[i];
			v += _getField(xdate2, false, i) - _getField(xdate1, false, i);
		}
		if (fieldIndex == MONTH) {
			v += (xdate2.getFullYear() - xdate1.getFullYear()) * 12;
		}
	}
	else if (fieldIndex == DATE) {
		var clear1 = xdate1.toDate().setUTCHours(0, 0, 0, 0); // returns an ms value
		var clear2 = xdate2.toDate().setUTCHours(0, 0, 0, 0); // returns an ms value
		v = Math.round((clear2 - clear1) / DAY_MS) + ((xdate2 - clear2) - (xdate1 - clear1)) / DAY_MS;
	}
	else {
		v = (xdate2 - xdate1) / [
			3600000, // milliseconds in hour
			60000,   // milliseconds in minute
			1000,    // milliseconds in second
			1        //
			][fieldIndex - 3];
	}
	return v;
}



/* Week Methods
---------------------------------------------------------------------------------*/


proto.getWeek = function() {
	return _getWeek(curry(_getField, this, false));
};


proto.getUTCWeek = function() {
	return _getWeek(curry(_getField, this, true));
};


proto.setWeek = function(n, year) {
	_setWeek(this, n, year, false);
	return this; // for chaining
};


proto.setUTCWeek = function(n, year) {
	_setWeek(this, n, year, true);
	return this; // for chaining
};


proto.addWeeks = function(delta) {
	return this.addDays(Number(delta) * 7);
};


proto.diffWeeks = function(otherDate) {
	return _diff(this, otherDate, DATE) / 7;
};


function _getWeek(getField) {
	return getWeek(getField(FULLYEAR), getField(MONTH), getField(DATE));
}


function getWeek(year, month, date) {
	var d = new Date(UTC(year, month, date));
	var week1 = getWeek1(
		getWeekYear(year, month, date)
	);
	return Math.floor(Math.round((d - week1) / DAY_MS) / 7) + 1;
}


function getWeekYear(year, month, date) { // get the year that the date's week # belongs to
	var d = new Date(UTC(year, month, date));
	if (d < getWeek1(year)) {
		return year - 1;
	}
	else if (d >= getWeek1(year + 1)) {
		return year + 1;
	}
	return year;
}


function getWeek1(year) { // returns Date of first week of year, in UTC
	var d = new Date(UTC(year, 0, 4));
	d.setUTCDate(d.getUTCDate() - (d.getUTCDay() + 6) % 7); // make it Monday of the week
	return d;
}


function _setWeek(xdate, n, year, useUTC) {
	var getField = curry(_getField, xdate, useUTC);
	var setField = curry(_setField, xdate, useUTC);

	if (year === undefined) {
		year = getWeekYear(
			getField(FULLYEAR),
			getField(MONTH),
			getField(DATE)
		);
	}

	var week1 = getWeek1(year);
	if (!useUTC) {
		week1 = coerceToLocal(week1);
	}

	xdate.setTime(week1.getTime());
	setField(DATE, [ getField(DATE) + (n-1) * 7 ]); // would have used xdate.addUTCWeeks :(
		// n-1 because n is 1-based
}



/* Parsing
---------------------------------------------------------------------------------*/


XDate.parsers = [
	parseISO
];


XDate.parse = function(str) {
	return +XDate(''+str);
};


function parse(str, utcMode, xdate) {
	var parsers = XDate.parsers;
	var i = 0;
	var res;
	for (; i<parsers.length; i++) {
		res = parsers[i](str, utcMode, xdate);
		if (res) {
			return res;
		}
	}
	xdate[0] = new Date(str);
	return xdate;
}


function parseISO(str, utcMode, xdate) {
	var m = str.match(/^(\d{4})(-(\d{2})(-(\d{2})([T ](\d{2}):(\d{2})(:(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/);
	if (m) {
		var d = new Date(UTC(
			m[1],
			m[3] ? m[3] - 1 : 0,
			m[5] || 1,
			m[7] || 0,
			m[8] || 0,
			m[10] || 0,
			m[12] ? Number('0.' + m[12]) * 1000 : 0
		));
		if (m[13]) { // has gmt offset or Z
			if (m[14]) { // has gmt offset
				d.setUTCMinutes(
					d.getUTCMinutes() +
					(m[15] == '-' ? 1 : -1) * (Number(m[16]) * 60 + (m[18] ? Number(m[18]) : 0))
				);
			}
		}else{ // no specified timezone
			if (!utcMode) {
				d = coerceToLocal(d);
			}
		}
		return xdate.setTime(d.getTime());
	}
}



/* Formatting
---------------------------------------------------------------------------------*/


proto.toString = function(formatString, settings, uniqueness) {
	if (formatString === undefined || !valid(this)) {
		return this[0].toString(); // already accounts for utc-mode (might be toUTCString)
	}else{
		return format(this, formatString, settings, uniqueness, getUTCMode(this));
	}
};


proto.toUTCString = proto.toGMTString = function(formatString, settings, uniqueness) {
	if (formatString === undefined || !valid(this)) {
		return this[0].toUTCString();
	}else{
		return format(this, formatString, settings, uniqueness, true);
	}
};


proto.toISOString = function() {
	return this.toUTCString(ISO_FORMAT_STRING_TZ);
};


XDate.defaultLocale = '';
XDate.locales = {
	'': {
		monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
		dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
		dayNamesShort: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
		amDesignator: 'AM',
		pmDesignator: 'PM'
	}
};
XDate.formatters = {
	i: ISO_FORMAT_STRING,
	u: ISO_FORMAT_STRING_TZ
};


function format(xdate, formatString, settings, uniqueness, useUTC) {

	var locales = XDate.locales;
	var defaultLocaleSettings = locales[XDate.defaultLocale] || {};
	var getField = curry(_getField, xdate, useUTC);

	settings = (isString(settings) ? locales[settings] : settings) || {};

	function getSetting(name) {
		return settings[name] || defaultLocaleSettings[name];
	}

	function getFieldAndTrace(fieldIndex) {
		if (uniqueness) {
			var i = (fieldIndex == DAY ? DATE : fieldIndex) - 1;
			for (; i>=0; i--) {
				uniqueness.push(getField(i));
			}
		}
		return getField(fieldIndex);
	}

	return _format(xdate, formatString, getFieldAndTrace, getSetting, useUTC);
}


function _format(xdate, formatString, getField, getSetting, useUTC) {
	var m;
	var subout;
	var out = '';
	while (m = formatString.match(formatStringRE)) {
		out += formatString.substr(0, m.index);
		if (m[1]) { // consecutive alphabetic characters
			out += processTokenString(xdate, m[1], getField, getSetting, useUTC);
		}
		else if (m[3]) { // parenthesis
			subout = _format(xdate, m[4], getField, getSetting, useUTC);
			if (parseInt(subout.replace(/\D/g, ''), 10)) { // if any of the numbers are non-zero. or no numbers at all
				out += subout;
			}
		}
		else { // else if (m[6]) { // single quotes
			out += m[7] || "'"; // if inner is blank, meaning 2 consecutive quotes = literal single quote
		}
		formatString = formatString.substr(m.index + m[0].length);
	}
	return out + formatString;
}


function processTokenString(xdate, tokenString, getField, getSetting, useUTC) {
	var end = tokenString.length;
	var replacement;
	var out = '';
	while (end > 0) {
		replacement = getTokenReplacement(xdate, tokenString.substr(0, end), getField, getSetting, useUTC);
		if (replacement !== undefined) {
			out += replacement;
			tokenString = tokenString.substr(end);
			end = tokenString.length;
		}else{
			end--;
		}
	}
	return out + tokenString;
}


function getTokenReplacement(xdate, token, getField, getSetting, useUTC) {
	var formatter = XDate.formatters[token];
	if (isString(formatter)) {
		return _format(xdate, formatter, getField, getSetting, useUTC);
	}
	else if (isFunction(formatter)) {
		return formatter(xdate, useUTC || false, getSetting);
	}
	switch (token) {
		case 'fff'  : return zeroPad(getField(MILLISECONDS), 3);
		case 's'    : return getField(SECONDS);
		case 'ss'   : return zeroPad(getField(SECONDS));
		case 'm'    : return getField(MINUTES);
		case 'mm'   : return zeroPad(getField(MINUTES));
		case 'h'    : return getField(HOURS) % 12 || 12;
		case 'hh'   : return zeroPad(getField(HOURS) % 12 || 12);
		case 'H'    : return getField(HOURS);
		case 'HH'   : return zeroPad(getField(HOURS));
		case 'd'    : return getField(DATE);
		case 'dd'   : return zeroPad(getField(DATE));
		case 'ddd'  : return getSetting('dayNamesShort')[getField(DAY)] || '';
		case 'dddd' : return getSetting('dayNames')[getField(DAY)] || '';
		case 'M'    : return getField(MONTH) + 1;
		case 'MM'   : return zeroPad(getField(MONTH) + 1);
		case 'MMM'  : return getSetting('monthNamesShort')[getField(MONTH)] || '';
		case 'MMMM' : return getSetting('monthNames')[getField(MONTH)] || '';
		case 'yy'   : return (getField(FULLYEAR)+'').substring(2);
		case 'yyyy' : return getField(FULLYEAR);
		case 't'    : return _getDesignator(getField, getSetting).substr(0, 1).toLowerCase();
		case 'tt'   : return _getDesignator(getField, getSetting).toLowerCase();
		case 'T'    : return _getDesignator(getField, getSetting).substr(0, 1);
		case 'TT'   : return _getDesignator(getField, getSetting);
		case 'z'    :
		case 'zz'   :
		case 'zzz'  : return useUTC ? 'Z' : _getTZString(xdate, token);
		case 'w'    : return _getWeek(getField);
		case 'ww'   : return zeroPad(_getWeek(getField));
		case 'S'    :
			var d = getField(DATE);
			if (d > 10 && d < 20) return 'th';
			return ['st', 'nd', 'rd'][d % 10 - 1] || 'th';
	}
}


function _getTZString(xdate, token) {
	var tzo = xdate.getTimezoneOffset();
	var sign = tzo < 0 ? '+' : '-';
	var hours = Math.floor(Math.abs(tzo) / 60);
	var minutes = Math.abs(tzo) % 60;
	var out = hours;
	if (token == 'zz') {
		out = zeroPad(hours);
	}
	else if (token == 'zzz') {
		out = zeroPad(hours) + ':' + zeroPad(minutes);
	}
	return sign + out;
}


function _getDesignator(getField, getSetting) {
	return getField(HOURS) < 12 ? getSetting('amDesignator') : getSetting('pmDesignator');
}



/* Misc Methods
---------------------------------------------------------------------------------*/


each(
	[ // other getters
		'getTime',
		'valueOf',
		'toDateString',
		'toTimeString',
		'toLocaleString',
		'toLocaleDateString',
		'toLocaleTimeString',
		'toJSON'
	],
	function(methodName) {
		proto[methodName] = function() {
			return this[0][methodName]();
		};
	}
);


proto.setTime = function(t) {
	this[0].setTime(t);
	return this; // for chaining
};


proto.valid = methodize(valid);
function valid(xdate) {
	return !isNaN(xdate[0].getTime());
}


proto.clone = function() {
	return new XDate(this);
};


proto.clearTime = function() {
	return this.setHours(0, 0, 0, 0); // will return an XDate for chaining
};


proto.toDate = function() {
	return new Date(this[0].getTime());
};



/* Misc Class Methods
---------------------------------------------------------------------------------*/


XDate.now = function() {
	return (new Date()).getTime();
};


XDate.today = function() {
	return new XDate().clearTime();
};


XDate.UTC = UTC;


XDate.getDaysInMonth = getDaysInMonth;



/* Internal Utilities
---------------------------------------------------------------------------------*/


function _clone(xdate) { // returns the internal Date object that should be used
	var d = new Date(xdate[0].getTime());
	if (getUTCMode(xdate)) {
		d.toString = toUTCString;
	}
	return d;
}


function _getField(d, useUTC, fieldIndex) {
	return d['get' + (useUTC ? 'UTC' : '') + methodSubjects[fieldIndex]]();
}


function _setField(d, useUTC, fieldIndex, args) {
	d['set' + (useUTC ? 'UTC' : '') + methodSubjects[fieldIndex]].apply(d, args);
}



/* Date Math Utilities
---------------------------------------------------------------------------------*/


function coerceToUTC(date) {
	return new Date(UTC(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		date.getHours(),
		date.getMinutes(),
		date.getSeconds(),
		date.getMilliseconds()
	));
}


function coerceToLocal(date) {
	return new Date(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds(),
		date.getUTCMilliseconds()
	);
}


function getDaysInMonth(year, month) {
	return 32 - new Date(UTC(year, month, 32)).getUTCDate();
}



/* General Utilities
---------------------------------------------------------------------------------*/


function methodize(f) {
	return function() {
		return f.apply(undefined, [this].concat(slice(arguments)));
	};
}


function curry(f) {
	var firstArgs = slice(arguments, 1);
	return function() {
		return f.apply(undefined, firstArgs.concat(slice(arguments)));
	};
}


function slice(a, start, end) {
	return Array.prototype.slice.call(
		a,
		start || 0, // start and end cannot be undefined for IE
		end===undefined ? a.length : end
	);
}


function each(a, f) {
	for (var i=0; i<a.length; i++) {
		f(a[i], i);
	};
}


function isString(arg) {
	return typeof arg == 'string';
}


function isNumber(arg) {
	return typeof arg == 'number';
}


function isBoolean(arg) {
	return typeof arg == 'boolean';
}


function isFunction(arg) {
	return typeof arg == 'function';
}


function zeroPad(n, len) {
	len = len || 2;
	n += '';
	while (n.length < len) {
		n = '0' + n;
	}
	return n;
}



// Export for Node.js
if (typeof module !== 'undefined' && module.exports) {
	module.exports = XDate;
}

// AMD
if (true) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return XDate;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


return XDate;

})(Date, Math, Array);


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callStickyHeaderFunc = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(isViewInvitation) {
        var ad;
        return regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        ad = document.getElementById('ad_mobile_top');


                        if (_evite2.default.detects.isMobile && _evite2.default.experiments.inExperiment('sticky_header')) {
                            initStickyHeader(isViewInvitation);
                            if (ad) {
                                // if there's an ad in the header, call the set up func again to adjust layout
                                _evite2.default.when('ad-mobile-top').then(function () {
                                    initStickyHeader(isViewInvitation, ad);
                                });
                            }
                        }

                    case 2:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee, this);
    }));

    return function callStickyHeaderFunc(_x) {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(485);

var _mobile_apps = __webpack_require__(486);

var _mobile_apps2 = _interopRequireDefault(_mobile_apps);

var _adskin = __webpack_require__(238);

var _adskin2 = _interopRequireDefault(_adskin);

var _side_menu = __webpack_require__(487);

var _side_menu2 = _interopRequireDefault(_side_menu);

__webpack_require__(488);

var _navigation = __webpack_require__(490);

var _notify = __webpack_require__(491);

var _sign_in_out = __webpack_require__(493);

var _sign_in_out2 = _interopRequireDefault(_sign_in_out);

var _search_icon = __webpack_require__(494);

var _search_icon2 = _interopRequireDefault(_search_icon);

var _pulldown = __webpack_require__(495);

var _pulldown2 = _interopRequireDefault(_pulldown);

var _subnav = __webpack_require__(496);

var _subnav2 = _interopRequireDefault(_subnav);

var _partner_integration = __webpack_require__(239);

var _ajax_csrf_setup = __webpack_require__(498);

var _evite = __webpack_require__(40);

var _evite2 = _interopRequireDefault(_evite);

var _utils = __webpack_require__(5);

var _retentionBank = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _evite$dom = _evite2.default.dom,
    hide = _evite$dom.hide,
    css = _evite$dom.css,
    show = _evite$dom.show;

// the following allows you to use the document.querySelectorAll('selector')::map syntax

var forEach = Array.prototype.forEach;

// PolyFill for new Event in IE

(function () {
    if (typeof window.CustomEvent === "function") return false; //If not IE

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

// PollyFill for DomParser.parseFromString
(function (DOMParser) {

    var DOMParser_proto = DOMParser.prototype,
        real_parseFromString = DOMParser_proto.parseFromString;

    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new DOMParser().parseFromString("", "text/html")) {
            // text/html parsing is natively supported
            return;
        }
    } catch (ex) {}

    DOMParser_proto.parseFromString = function (markup, type) {
        if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
            var doc = document.implementation.createHTMLDocument("");
            if (markup.toLowerCase().indexOf('<!doctype') > -1) {
                doc.documentElement.innerHTML = markup;
            } else {
                doc.body.innerHTML = markup;
            }
            return doc;
        } else {
            return real_parseFromString.apply(this, arguments);
        }
    };
})(DOMParser);

/** Notification Center **/
var notificationCenterSetup = function notificationCenterSetup() {
    if (!window.client_data.is_logged_in) return;

    var navCenter = document.getElementById('nav_nctr');
    if (!navCenter) return;
    window.notifications = new _notify.NotificationsCollection({
        fetchCallback: function fetchCallback(collection) {
            if (collection.models.length === 0) {
                var bell = document.body.querySelector('#nav_nctr .icon-notification');
                if (bell) bell.setAttribute('class', 'icon icon-notification-empty');
            }
        }
    });
    _evite2.default.when('document.ready', 'block js').then(function () {
        var _context;

        var nav_support = true;
        var nav_center_pulldown = null;

        (_context = document.getElementsByClassName('unviewed-count'), forEach).call(_context, function (element) {
            new _notify.NotificationsBadgeView({
                el: element,
                collection: notifications
            });
        });

        (_context = document.getElementsByClassName('account-more'), forEach).call(_context, function (element) {
            var pulldown = new _pulldown2.default({
                el: element
            });
            if (element.id === "nav_nctr") {
                nav_center_pulldown = pulldown;
            }
        });

        if (navCenter) {
            new _notify.NotificationCenterView({
                el: navCenter,
                collection: notifications,
                pulldown: nav_center_pulldown,
                nav_support: nav_support
            });

            if (_evite2.default.features.isEnabled('navigation-center-header-button')) {
                _evite2.default.show(navCenter);
            }
        }

        if (document.location.pathname === '/all-notifications') {
            new _notify.NotificationCenterView({
                el: document.getElementById('all_notifications'),
                collection: notifications,
                pulldown: null,
                nav_support: false
            });
        }
    });
};
/** End Notification Center **/

/** NavBar **/
var navBarSetup = function navBarSetup() {
    window.evite.resolve('sign-in-view', new _sign_in_out2.default());
    /**
     ** End Sign In/Out View in NAV
     **/

    if (window.is_modal === true) {
        // don't want to do this stuff in a modal
        return;
    }

    _side_menu2.default.create();
    var header = document.getElementById('header');
    var spacer = document.getElementById('header_spacer');
    var isViewInvitation = _evite2.default.hasClass(header, 'view-invitation');

    if (!header) return;

    // if it's view invitation, we need to wait for the component
    // to fully mount before we can calculate offsetHeights
    if (isViewInvitation) {
        _evite2.default.when('view-invitation-loaded').then(function () {
            callStickyHeaderFunc(isViewInvitation);
        });
    } else {
        callStickyHeaderFunc(isViewInvitation);
    }

    if (!spacer) return;

    window.card_height = _utils.card_height;
    window.popup_window = _utils.popup_window;
    if (window.is_mobile_site && !window.is_card) {
        window.menu_padding = 52; // allow space for top menu/nav bar on mobile
    } else {
        window.menu_padding = 0;
    }

    if (window.browserBlast) {
        window.browserBlast({
            devMode: false,
            supportedIE: '11',
            message: 'You are using an old version of Internet Explorer that is not supported by Evite. Please <a href="http://browsehappy.com" target="_blank">upgrade</a> for the best experience.'
        });
    }

    var cookieWarning = document.getElementById('cookie-warning');
    if (!window.location.hash) {
        if (cookieWarning && !_retentionBank.local.get('cookie-warning')) {
            _retentionBank.local.set('cookie-warning', 1);

            show(cookieWarning);
            css(cookieWarning, null);
            css(spacer, { height: header.clientHeight + window.menu_padding });

            if (_evite2.default.detects.isMobile) {
                var navElem = document.getElementById("event_view_tabs");
                if (navElem) {
                    // move down the event view tab bar by the height of the cookie warning div
                    var currTop = navElem.offset.top;
                    var warningHeight = cookieWarning.clientHeight;
                    navElem.offset.top = currTop + warningHeight;
                }
            }
        }
    }

    if (cookieWarning) {
        (0, _evite.liveBind)(cookieWarning, 'click', 'a.close', function () {
            hide(cookieWarning);
            window.cookie_dismissed = true;
            css(spacer, { height: header.clientHeight + window.menu_padding });
        });
    }

    new _search_icon2.default();
    css(spacer, { height: header.clientHeight + window.menu_padding });
    (0, _subnav2.default)();
};

function initStickyHeader(isViewInvitation, ad) {
    var headerEl = document.getElementById('header');
    var universalNavEl = headerEl.querySelector('.universal-nav.mobile');
    var mobileTabsEl = document.querySelector('.mobile-event-view-tabs');
    var adHeight = ad ? ad.clientHeight : 0;
    var headerElHeight = isViewInvitation ? adHeight + universalNavEl.offsetHeight + mobileTabsEl.offsetHeight : headerEl.offsetHeight;

    // add div to push down content so fixed header doesn't cover it
    _evite2.default.css(document.getElementById('fixed-header-spacer'), { height: headerElHeight });

    if (ad) {
        var offsetToRemoveAd = headerElHeight * 2;
        var offsetToShowAd = headerElHeight;

        _evite2.default.addClass(document.getElementById('slide_right'), 'withAd');
        if (isViewInvitation) {
            _evite2.default.css(mobileTabsEl, { top: adHeight + universalNavEl.offsetHeight - 2 });
        }

        document.addEventListener('scroll', function (event) {
            var currOffset = window.pageYOffset;

            if (currOffset > offsetToRemoveAd) {
                _evite2.default.css(ad, { marginTop: adHeight * -1 });
                // view invitation has two non-adjacent headers
                if (isViewInvitation) {
                    _evite2.default.css(universalNavEl, { marginTop: isViewInvitation ? 0 : adHeight * -1 });
                    _evite2.default.css(mobileTabsEl, { marginTop: adHeight * -1 });
                }
            } else if (currOffset < offsetToShowAd) {
                _evite2.default.css(ad, { marginTop: 0 });
                // view invitation has two non-adjacent headers
                if (isViewInvitation) {
                    _evite2.default.css(universalNavEl, { marginTop: 0 });
                    _evite2.default.css(mobileTabsEl, { marginTop: 0 });
                }
            }
        });
    } else if (isViewInvitation) {
        _evite2.default.css(mobileTabsEl, { top: universalNavEl.offsetHeight + adHeight - 2 });
    }
}
/** End NavBar **/

/** MEGA NAV **/
_evite2.default.when('block js', 'page.render').then(function () {
    if (_evite2.default.detects.isDesktop) {
        var header = document.getElementById('header'),
            mega = document.getElementsByClassName('mega-nav-wrapper'),
            invitationLi = document.getElementById('create_invitation_li'),
            cardsLi = document.getElementById('cards_li'),
            planningLi = document.getElementById('party_planning_li'),
            megaClose = document.getElementsByClassName('mega-nav-close'),
            headerHeight = header ? header.clientHeight : 0;

        if (!header) return;

        if (mega.length < 1 || megaClose.length < 1) return; // not all pages have the entire menu (event view it's not present)

        for (var i = 0; i < mega.length; i++) {
            mega[i].style.top = headerHeight + 'px';
            megaClose[i].addEventListener('click', _navigation.handleMegaNavCloseLinkClick);
        }

        if (invitationLi) {
            invitationLi.addEventListener("mouseover", function () {
                show(document.getElementById('mega-nav'));
            });
        }
        if (cardsLi) {
            cardsLi.addEventListener("mouseover", function () {
                show(document.getElementById('mega-nav-cards'));
            });
        }
        if (planningLi) {
            planningLi.addEventListener("mouseover", function () {
                show(document.getElementById('mega-nav-planning'));
            });
        }
    }

    var megaMore = document.getElementsByClassName('mega-more');
    for (var _i = 0; _i < megaMore.length; _i++) {
        megaMore[_i].addEventListener('click', _navigation.handleMegaNavMoreLinkClick);
    }
});
/** END MEGA NAV **/

/** Main Init **/
var runMainInit = function runMainInit() {
    var partner_data = window.partner_data;
    if (!partner_data) {
        partner_data = {};
    }

    window.partner_integration = new _partner_integration.PartnerIntegration(partner_data);

    /*
        Fix for fixed elements on mobile browsers which tend to jump around when form fields are focused on,
        due to the mobile keyboard sliding up.
        This 'unfixes' the fixed elements and prevents the mobile keyboard form causing issues.
    */
    if ('ontouchstart' in document.documentElement) {
        var bodyNode = document.querySelector('body');
        (0, _evite.liveBind)(bodyNode, 'focus', 'input, textarea', function () {
            return bodyNode.classList.add('fixFixed');
        });
        (0, _evite.liveBind)(bodyNode, 'blur', 'input, textarea', function () {
            return bodyNode.classList.remove('fixFixed');
        });
    }

    (0, _utils.configure_selectboxes)();
    new _mobile_apps2.default();
    window.AdSkin = _adskin2.default;
    _evite2.default.resolvePromiseByName('adSkin', _adskin2.default);
};
/** End Main Init **/

_evite2.default.logAndContinue(_ajax_csrf_setup.ajax_csrf_setup);
_evite2.default.logAndContinue(navBarSetup);
_evite2.default.logAndContinue(notificationCenterSetup);
_evite2.default.logAndContinue(runMainInit);

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {(function(c){function l(a){return a?"object"==typeof a||"function"==typeof a:!1}if(!c.Proxy){var m=null;c.a=function(a,b){function c(){}if(!l(a)||!l(b))throw new TypeError("Cannot create proxy with a non-object as target or handler");m=function(){c=function(a){throw new TypeError("Cannot perform '"+a+"' on a proxy that has been revoked");}};var e=b;b={get:null,set:null,apply:null,construct:null};for(var h in e){if(!(h in b))throw new TypeError("Proxy polyfill does not support trap '"+h+"'");b[h]=
e[h]}"function"==typeof e&&(b.apply=e.apply.bind(e));var d=this,n=!1,p="function"==typeof a;if(b.apply||b.construct||p)d=function(){var g=this&&this.constructor===d,f=Array.prototype.slice.call(arguments);c(g?"construct":"apply");if(g&&b.construct)return b.construct.call(this,a,f);if(!g&&b.apply)return b.apply(a,this,f);if(p)return g?(f.unshift(a),new (a.bind.apply(a,f))):a.apply(this,f);throw new TypeError(g?"not a constructor":"not a function");},n=!0;var q=b.get?function(a){c("get");return b.get(this,
a,d)}:function(a){c("get");return this[a]},t=b.set?function(a,f){c("set");b.set(this,a,f,d)}:function(a,b){c("set");this[a]=b},r={};Object.getOwnPropertyNames(a).forEach(function(b){n&&b in d||(Object.defineProperty(d,b,{enumerable:!!Object.getOwnPropertyDescriptor(a,b).enumerable,get:q.bind(a,b),set:t.bind(a,b)}),r[b]=!0)});e=!0;Object.setPrototypeOf?Object.setPrototypeOf(d,Object.getPrototypeOf(a)):d.__proto__?d.__proto__=a.__proto__:e=!1;if(b.get||!e)for(var k in a)r[k]||Object.defineProperty(d,
k,{get:q.bind(a,k)});Object.seal(a);Object.seal(d);return d};c.a.b=function(a,b){return{proxy:new c.a(a,b),revoke:m}};c.a.revocable=c.a.b;c.Proxy=c.a}})("undefined"!==typeof process&&"[object process]"=={}.toString.call(process)?global:self);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(129), __webpack_require__(6)))

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _evite = __webpack_require__(40);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var forEach = Array.prototype.forEach;

var MobileAppPageView = function () {
    function MobileAppPageView() {
        var _context;

        _classCallCheck(this, MobileAppPageView);

        var $navs = document.querySelectorAll('.app-nav');
        var currentUrl = this.getParameterByName('app');
        var $body = document.querySelector('body');
        var left = void 0,
            right = void 0;

        var $currentLink = document.querySelectorAll('.app-nav[data-id="' + currentUrl + '"]');
        var $contentToDisplay = document.querySelectorAll('.app-wrap[id="' + currentUrl + '"]');

        if ($contentToDisplay.length) {
            left = $contentToDisplay[0].querySelector('.left');
            right = $contentToDisplay[0].querySelector('.right');
        }

        if (typeof window.is_mobile_site !== 'undefined' && window.is_mobile_site) {
            $body.classList.remove('side-menu-active');
        } else {
            forEach.call($navs, function (el) {
                return el.classList.remove('selected');
            });
            if ($currentLink.length) $currentLink.classList.add('selected');
        }

        (_context = document.querySelectorAll('.app-wrap'), forEach).call(_context, function (el) {
            return el.classList.add('closed');
        });
        forEach.call($contentToDisplay, function (el) {
            return el.classList.remove('closed');
        });

        (0, _evite.liveBind)($body, 'swipeleft', '.mobile-marketing', function () {
            if (right) {
                window.location.href = right;
            }
        });
        (0, _evite.liveBind)($body, 'swiperight', '.mobile-marketing', function () {
            if (left) {
                window.location.href = left;
            }
        });
    }

    _createClass(MobileAppPageView, [{
        key: 'getParameterByName',
        value: function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);

            if (!results || !results[2]) {
                return 'evite-app';
            }

            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    }]);

    return MobileAppPageView;
}();

exports.default = MobileAppPageView;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _evite = __webpack_require__(40);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// -------------------------------------------------------
// --------------------- Side menu -----------------------
// -------------------------------------------------------

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest) Element.prototype.closest = function (selector) {
    var el = this;
    while (el) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }
};

var MenuSlide = function () {
    _createClass(MenuSlide, null, [{
        key: 'create',
        value: function create() {
            var el = document.querySelector('#side_menu');
            var header = document.querySelector('#header');
            if (el && header) {
                return new MenuSlide({ el: el, header: header });
            }
            return null;
        }
    }]);

    function MenuSlide() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, MenuSlide);

        this.toggleDetails = function (event) {
            event.preventDefault();
            var details = event.target.parentNode;
            if (details) {
                details.setAttribute('aria-expanded', details.getAttribute('aria-expanded') !== 'true');
            }
            return false;
        };

        this.toggleMenu = function () {
            _this.isActive ? _this.closeMenu() : _this.openMenu();
        };

        this.openMenu = function () {
            _this.el.classList.add('side-menu-active');
            $('body').addClass('side-menu-active');
        };

        this.closeMenu = function () {
            _this.el.classList.remove('side-menu-active');
            $('body').removeClass('side-menu-active');
        };

        this.closeMenuPreventDefault = function (event) {
            event.preventDefault();
            _this.closeMenu();
        };

        this.el = evite.assertInstanceOf(options.el, HTMLElement);
        this.header = evite.assertInstanceOf(options.header, HTMLElement);

        evite.when('jquery', 'block footer').then(function () {
            _this.bindEvents();
            Array.from(document.querySelectorAll('.accordion-nav')).forEach(function (el) {
                return new NavAccordionToggle({ el: el });
            });
        });
    }

    _createClass(MenuSlide, [{
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _evite.liveBind)(this.el, 'click', '.register-signin', this.closeMenu);
            (0, _evite.liveBind)(this.el, 'click', '.content-mask', this.closeMenuPreventDefault);
            (0, _evite.liveBind)(this.el, 'click', '.details .summary', this.toggleDetails);
            (0, _evite.liveBind)(this.header, 'click', '.menu-button.button-nav', this.toggleMenu);

            (0, _evite.liveBind)(document.body, 'click', '.create-invitation-button', this.toggleMenu);
            (0, _evite.liveBind)(document.body, 'click', '.browse-gallery-button-top', this.toggleMenu);
            (0, _evite.liveBind)(document.body, 'click', '.browse-gallery-button-bottom', this.toggleMenu);
            (0, _evite.liveBind)(document.body, 'click', '.browse-occasions-button', this.toggleMenu);
            (0, _evite.liveBind)(document.body, 'swipeleft', '#side_menu', this.closeMenu);

            var mask = document.querySelector('.content-mask');
            if (mask) {
                mask.addEventListener('click', this.closeMenu);
                mask.addEventListener('swipeleft', this.closeMenu);
            }
        }
    }, {
        key: 'isActive',
        get: function get() {
            return this.el.classList.contains('side-menu-active');
        }
    }, {
        key: 'details',
        get: function get() {
            return this.el.querySelector('.details');
        }
    }, {
        key: 'summary',
        get: function get() {
            return this.el.querySelector('.summary');
        }
    }]);

    return MenuSlide;
}();

var NavAccordionToggle = function NavAccordionToggle(options) {
    _classCallCheck(this, NavAccordionToggle);

    this.toggleAccordion = function (event) {
        event.preventDefault();
        var header = event.target.closest('.accordion-nav');
        var currentActive = document.querySelector('.ui-accordion:not(.collapsed)');

        if (header.parentNode.classList.contains('collapsed')) {
            currentActive.querySelector('ul');
            currentActive.querySelectorAll('.accordion-nav').forEach(function (el) {
                return el.classList.add('inactive');
            });
            currentActive.classList.add('collapsed');
        }
        header.parentNode.querySelector('ul');
        header.parentNode.classList.remove('collapsed');
        header.classList.remove('inactive');
    };

    this.el = options.el;
    this.el.addEventListener('click', this.toggleAccordion);
};

exports.default = MenuSlide;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

var _evite = __webpack_require__(40);

var _evite2 = _interopRequireDefault(_evite);

var _search_model = __webpack_require__(489);

var _search_model2 = _interopRequireDefault(_search_model);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOWN_ARROW_KEY = 40,
    UP_ARROW_KEY = 38,
    ENTER_KEY = 13;
var _evite$dom = _evite2.default.dom,
    addClass = _evite$dom.addClass,
    appendChild = _evite$dom.appendChild,
    createElement = _evite$dom.createElement,
    hasClass = _evite$dom.hasClass,
    hide = _evite$dom.hide,
    removeClass = _evite$dom.removeClass,
    removeChildren = _evite$dom.removeChildren,
    toggle = _evite$dom.toggle;
var assertString = _evite2.default.assertString;

var SearchComponent = function () {
  function SearchComponent(options) {
    var _this = this;

    _classCallCheck(this, SearchComponent);

    this.hovering = false;
    this.isAnimating = false;

    this.submitSuggestionElement = function (event, element) {
      var isNoMatches = element && hasClass(element, 'no-matches');
      if (isNoMatches) {
        return;
      }

      var id = element.dataset.id;
      var type = element.dataset.category ? _search_model2.default.TYPE_CATEGORY : element.dataset.suggestions ? _search_model2.default.TYPE_SUGGESTION : element.dataset.hints ? _search_model2.default.TYPE_HINT : '';
      var model = _this.model.findWhere({ id: id, type: type });
      if (!model) {
        _evite2.default.error('Cannot find model by id:' + id + ' type:' + type);
      } else {
        _this.searchTerm = model.type === _search_model2.default.TYPE_HINT ? model.id : model.text;

        if (_this.submitModel) {
          if (_this.submitModel(model) === false) {
            event.preventDefault();
          }
        }
      }

      _this.blur();
    };

    this.focus = function () {
      addClass(_this.el, 'active');
      addClass(_this.submitButton, 'active');
      addClass(_this.suggestionList, 'active');
      addClass(_this.searchInput, 'active');

      _this.invalidateDropdownbox();
      _this.select();
    };

    this.blur = function () {
      if (!_this.hovering) {
        hide(_this.suggestionList);
        removeClass(_this.el, 'active');
        removeClass(_this.submitButton, 'active');
        removeClass(_this.suggestionList, 'active');
        removeClass(_this.searchInput, 'active');
      }
    };

    this.scrollElementIntoView = function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(element) {
        var previousSibling, currentPosition, isEmpty, jQuery;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (element) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                previousSibling = element.previousSibling;

                if (previousSibling && hasClass(previousSibling, 'title')) {
                  element = previousSibling;
                }

                currentPosition = element.offsetTop;
                isEmpty = !_this.suggestionList.firstChild;

                if (!(isEmpty || _this.suggestionList.scrollTop === currentPosition)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:

                _this.isAnimating = true;

                // TODO - investigate removing jQuery here
                _context.next = 11;
                return _evite2.default.when('jquery');

              case 11:
                jQuery = _context.sent;

                _this.$suggestionList = _this.$suggestionList || jQuery(_this.suggestionList);
                _this.$suggestionList.animate({ scrollTop: currentPosition }, 50);

                if (_this.timeoutId) {
                  clearTimeout(_this.timeoutId);
                }
                _this.timeoutId = setTimeout(function () {
                  _this.isAnimating = false;
                }, 200);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.turnOnHovering = function () {
      _this.hovering = true;
    };

    this.turnOffHovering = function () {
      _this.hovering = false;
    };

    this.handleSubmitButtonClick = function (event) {
      event.preventDefault();
      _this.submit();
      _this.blur();
      return false;
    };

    this.handleSuggestionClick = function (event) {
      event.preventDefault();
      _this.hovering = false;
      _this.submitSuggestionElement(event, event.target);
      return false;
    };

    this.handleSuggestionMouseOver = function (event) {
      var entryElement = event.target;
      while (entryElement && !hasClass(entryElement, 'entry')) {
        entryElement = entryElement.nextSibling;
      }

      if (!_this.isAnimating) {
        _this.selectedElement = entryElement;
      }
    };

    this.handleSearchKeyDown = function (event) {
      if (event.keyCode === DOWN_ARROW_KEY || event.keyCode === UP_ARROW_KEY) {
        event.preventDefault();
        _this.select();
        return false;
      }
    };

    this.handleSearchKeyUp = function (event) {
      switch (event.keyCode) {
        case ENTER_KEY:
          return void _this.handleEnterKey(event);
        case DOWN_ARROW_KEY:
          return void _this.handleDownArrowKey(event);
        case UP_ARROW_KEY:
          return void _this.handleUpArrowKey(event);
      }
    };

    this.handleSearchInput = function (event) {
      _this.invalidateDropdownbox();
    };

    this.handleHistoryChange = function (event) {
      var params = (0, _utils.parseParams)(location.search.slice(1));
      _this.searchTerm = params[_this.queryParamName] || '';
    };

    this.model = options.model || new _search_model2.default({ 'urlName': options.urlName });
    this.model.urlName = assertString(options.urlName);

    this.queryParamName = options.queryParamName || '';
    this.el = _evite2.default.assert(options.el);
    this.form = _evite2.default.assert(options.form);
    this.searchInput = _evite2.default.assert(options.searchInput);
    this.submitButton = options.submitButton || createElement('<button class="search-submit-button" />');
    this.suggestionList = options.suggestionList || createElement('<ul class="search-ul" />');
    this.searchLocationElement = options.searchLocationInput || createElement('<input name="search_location" />');
    this.preventDropdown = !options.suggestionList;

    this.select = _.debounce(this.select.bind(this), 100, { leading: true, trailling: false });
    this.focus = _.debounce(this.focus.bind(this), 100, { leading: true, trailling: false });

    // TODO - remove ignore submit
    this.ignoreSubmit = options.ignoreSubmit;
    this.submitModel = options.submitModel ? options.submitModel.bind(this) : null;
    this.enableSuggestionTitles = Boolean(options.enableSuggestionTitles);

    if (!this.enableSuggestionTitles) {
      addClass(this.el, 'no-search-titles');
    }
    hide(this.suggestionList);
    removeChildren(this.suggestionList);
    addClass(this.el, 'initialized');

    this.bindEvents();

    if (this.searchTerm) {
      this.search(this.searchTerm);
    }

    if (this.queryParamName) {
      _evite2.default.history.addEventListener('change', this.handleHistoryChange);
    }
  }

  _createClass(SearchComponent, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.searchInput.addEventListener('focus', this.focus);
      this.searchInput.addEventListener('blur', this.blur);
      this.searchInput.addEventListener('keydown', this.handleSearchKeyDown);
      this.searchInput.addEventListener('keyup', this.handleSearchKeyUp);
      this.searchInput.addEventListener('input', this.handleSearchInput);
      this.form.addEventListener('submit', function (e) {
        return e.preventDefault();
      });
      this.suggestionList.addEventListener('mouseover', this.turnOnHovering);
      this.suggestionList.addEventListener('mouseleave', this.turnOffHovering);
      this.submitButton.addEventListener('click', this.handleSubmitButtonClick);
    }
  }, {
    key: 'submit',
    value: function submit() {
      this.form.submit();
    }
  }, {
    key: 'select',
    value: function select() {
      this.searchInput.select();
    }
  }, {
    key: 'invalidateDropdownbox',
    value: function invalidateDropdownbox() {
      if (this.preventDropdown || !this.searchTerm) {
        hide(this.suggestionList);
        return;
      }

      var isNoMatches = hasClass(this.suggestionList.firstChild, 'no-matches');
      var isCurrentSearch = this.currentSearch === this.searchTerm;

      if (!isCurrentSearch && isNoMatches) {
        hide(this.suggestionList);
      }

      this.search(this.searchTerm);
    }
  }, {
    key: 'search',
    value: function () {
      var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(searchTerm) {
        var model, json, categoryListItems, suggestionListItems, hintListItems;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                model = this.model;

                this.currentSearch = searchTerm;
                _context2.next = 4;
                return this.model.fetch(searchTerm);

              case 4:
                json = _context2.sent;

                if (!(this.currentSearch === json.search)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 8;
                return this.model.sync(json);

              case 8:
                categoryListItems = this.createListItems({
                  title: 'Invitation Categories',
                  dataName: 'category',
                  className: 'category',
                  collection: model.categoryCollection
                });
                suggestionListItems = this.createListItems({
                  title: 'Suggestions',
                  dataName: 'suggestions',
                  className: 'suggestion',
                  collection: model.suggestionCollection
                });
                hintListItems = this.createListItems({
                  title: 'Keywords',
                  dataName: 'hints',
                  className: 'hint',
                  collection: model.hintCollection
                });


                this.renderListItems({
                  categoryListItems: categoryListItems,
                  suggestionListItems: suggestionListItems,
                  hintListItems: hintListItems
                });

              case 12:

                if (!hasClass(this.el, 'active') && document.activeElement === this.searchInput) {
                  addClass(this.el, 'active');
                  addClass(this.submitButton, 'active');
                  addClass(this.suggestionList, 'active');
                  addClass(this.searchInput, 'active');

                  this.invalidateDropdownbox();
                }

                toggle(this.suggestionList, hasClass(this.el, 'active') && Boolean(this.suggestionList.firstChild));

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search(_x2) {
        return _ref2.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: 'renderListItems',
    value: function renderListItems(_ref3) {
      var categoryListItems = _ref3.categoryListItems,
          suggestionListItems = _ref3.suggestionListItems,
          hintListItems = _ref3.hintListItems;

      var suggestionList = this.suggestionList;
      this.removeListItem(suggestionList);

      var dropDownListItems = [].concat(categoryListItems).concat(suggestionListItems).concat(hintListItems);

      if (dropDownListItems.length) {
        this.appendListItems(suggestionList, dropDownListItems);
        return;
      }

      var listItem = createElement('<li class="search-li no-matches">No matches</li>');
      appendChild(this.suggestionList, listItem);
    }
  }, {
    key: 'removeListItem',
    value: function removeListItem(suggestionList) {
      var listItem = void 0;
      while (listItem = suggestionList.lastChild) {
        if (hasClass(listItem, 'entry')) {
          listItem.removeEventListener('click', this.handleSuggestionClick);
        }
        listItem.removeEventListener('mouseover', this.handleSuggestionMouseOver);

        suggestionList.removeChild(listItem);
      }
    }
  }, {
    key: 'appendListItems',
    value: function appendListItems(suggestionList, dropDownListItems) {
      for (var i = 0; i < dropDownListItems.length; ++i) {
        var listItem = dropDownListItems[i];
        if (hasClass(listItem, 'entry')) {
          listItem.addEventListener('click', this.handleSuggestionClick);
        }
        listItem.addEventListener('mouseover', this.handleSuggestionMouseOver);

        appendChild(suggestionList, listItem);
      }
    }
  }, {
    key: 'createListItems',
    value: function createListItems(_ref4) {
      var title = _ref4.title,
          dataName = _ref4.dataName,
          className = _ref4.className,
          collection = _ref4.collection;

      var listItems = [];
      if (collection && collection.length) {

        if (this.enableSuggestionTitles) {
          var listItem = _evite2.default.dom.createElement('<li class="search-li ' + className + ' title" role="heading">' + title + '</li>');
          listItems.push(listItem);
        }

        for (var i = 0; i < collection.length; ++i) {
          var model = collection[i];
          var text = model.text,
              id = model.id;
          // TODO - remove data-${dataName}

          var _listItem = _evite2.default.dom.createElement('<li class="search-li ' + className + ' entry" data-id="' + id + '" data-' + dataName + '="' + id + '" role="option">' + text + '</li>');

          var isFirst = !i;
          if (isFirst) {
            addClass(_listItem, 'first-of-entry-group');
          }

          var isLast = i === collection.length - 1;
          if (isLast) {
            addClass(_listItem, 'last-of-entry-group');
          }

          listItems.push(_listItem);
        }
      }

      return listItems;
    }
  }, {
    key: 'handleEnterKey',
    value: function handleEnterKey(event) {
      if (this.selectedElement) {
        this.submitSuggestionElement(event, this.selectedElement);
      } else if (!this.ignoreSubmit) {
        this.submit();
      }
    }
  }, {
    key: 'handleDownArrowKey',
    value: function handleDownArrowKey(event) {
      var selectedElement = this.selectedElement;
      var nextSibling = selectedElement && selectedElement.nextSibling;
      var nextEntry = nextSibling;
      while (nextEntry && !hasClass(nextEntry, 'entry')) {
        nextEntry = nextEntry.nextSibling;
      }

      var firstChild = this.suggestionList.firstChild;

      var firstEntry = firstChild;
      while (firstEntry && !hasClass(firstEntry, 'entry')) {
        firstEntry = firstEntry.nextSibling;
      }

      var newSelectedElement = nextEntry || firstEntry;
      if (newSelectedElement) {
        this.selectedElement = newSelectedElement;
      }

      this.scrollElementIntoView(this.selectedElement);
    }
  }, {
    key: 'handleUpArrowKey',
    value: function handleUpArrowKey(event) {
      var selectedElement = this.selectedElement;
      var previousSibling = selectedElement && selectedElement.previousSibling;
      var previousEntry = previousSibling;
      while (previousEntry && !hasClass(previousEntry, 'entry')) {
        previousEntry = previousEntry.previousSibling;
      }

      var lastChild = this.suggestionList.lastChild;

      var lastEntry = lastChild;
      while (lastEntry && !hasClass(lastEntry, 'entry')) {
        lastEntry = lastEntry.previousSibling;
      }

      var newSelectedElement = previousEntry || lastEntry;
      if (newSelectedElement) {
        this.selectedElement = newSelectedElement;
      }

      this.scrollElementIntoView(this.selectedElement);
    }
  }, {
    key: 'searchTerm',
    get: function get() {
      return _search_model2.default.normalizeSearch(this.searchInput.value || '');
    },
    set: function set(str) {
      this.searchInput.value = str || '';
    }
  }, {
    key: 'selectedElement',
    get: function get() {
      return this.el.querySelector('.selected');
    },
    set: function set(element) {
      var selectedElement = this.selectedElement;

      if (selectedElement && selectedElement !== element) {
        removeClass(selectedElement, 'selected');
      }

      if (element && selectedElement !== element) {
        addClass(element, 'selected');
      }
    }
  }, {
    key: 'searchLocation',
    get: function get() {
      return this.searchLocationElement && this.searchLocationElement.value || '';
    }
  }]);

  return SearchComponent;
}();

exports.default = SearchComponent;


SearchComponent.factory = function (id) {
  if (!id) {
    return Array.from(document.querySelectorAll('.search-component:not(.initialized), .suggestion-search:not(.initialized)')).map(function (el) {
      var id = el.getAttribute('id');

      if (!id) {
        id = _evite2.default.guid('search-component');
        el.setAttribute('id', id);
      }

      return SearchComponent.factory(id);
    });
  }

  var el = document.getElementById(id);
  var searchInput = el && el.querySelector('input[type="search"]');

  if (!el || !searchInput) {
    return null;
  }

  var form = el.querySelector('form');
  var suggestionList = el.querySelector('ul');
  var searchLocationInput = el.querySelector('[name="search_location"]');
  var searchIcon = el.querySelector('.search-icon');
  var submitButton = el.querySelector('.submit-button') || el.querySelector('[type="submit"]') || searchIcon;

  // TODO - reduce repeated code / remove id reference
  if (id === 'event_search_box') {
    return new SearchComponent({
      el: el,
      form: form,
      searchInput: searchInput,
      submitButton: submitButton,
      suggestionList: suggestionList,
      searchLocationInput: searchLocationInput,
      ignoreSubmit: true,
      enableSuggestionTitles: true,
      urlName: 'ajax_event_suggestions',
      submitModel: function submitModel(model) {
        var type = model.type,
            id = model.id;

        if (type !== 'suggestion') {
          return false;
        }
        window.location = _urls2.default.get('view', { event_id: id });
      }
    });
  }

  return new SearchComponent({
    el: el,
    form: form,
    searchInput: searchInput,
    submitButton: submitButton,
    suggestionList: suggestionList,
    searchLocationInput: searchLocationInput,
    ignoreSubmit: false,
    enableSuggestionTitles: true,
    queryParamName: 'query',
    urlName: 'ajax_gallery_suggestions',
    submitModel: function submitModel(model) {
      if (model.type === 'category') {
        var category = model.id;
        var searchLocation = this.searchLocation,
            searchTerm = this.searchTerm;


        var baseUrl = _urls2.default.get('gallery/category', { category: category });
        window.location = baseUrl + '?search_location=' + searchLocation + '&query=' + searchTerm;

        return false;
      }
      this.submit();
    }
  });
};

_evite2.default.when('block body').then(SearchComponent.factory);
_evite2.default.when('block footer').then(SearchComponent.factory);

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _evite = __webpack_require__(40);

var _evite2 = _interopRequireDefault(_evite);

var _collection = __webpack_require__(301);

var _collection2 = _interopRequireDefault(_collection);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var intervalId = 0;
var FIVE_MINUTES = 1000 * 60 * 5;
var cache = new Map();
var memoise = new Map();

// TODO - refactor

var SearchModel = function () {
  _createClass(SearchModel, null, [{
    key: 'TYPE_CATEGORY',
    get: function get() {
      return 'category';
    }
  }, {
    key: 'TYPE_SUGGESTION',
    get: function get() {
      return 'suggestion';
    }
  }, {
    key: 'TYPE_HINT',
    get: function get() {
      return 'hint';
    }
  }]);

  function SearchModel(attributes) {
    _classCallCheck(this, SearchModel);

    this.categories = [];
    this.suggestions = [];
    this.hints = [];

    Object.assign(this, attributes || {});

    this.categoryCollection = new _collection2.default([], { model: SearchSuggestionModel });
    this.suggestionCollection = new _collection2.default([], { model: SearchSuggestionModel });
    this.hintCollection = new _collection2.default([], { model: SearchSuggestionModel });

    if (!intervalId) {
      intervalId = setInterval(function () {
        cache.clear();
      }, FIVE_MINUTES);
    }
  }

  _createClass(SearchModel, [{
    key: 'findWhere',
    value: function findWhere(options) {
      return options && this.categoryCollection.findWhere(options) || this.suggestionCollection.findWhere(options) || this.hintCollection.findWhere(options) || null;
    }
  }, {
    key: 'fetch',
    value: function fetch(search) {
      search = SearchModel.normalizeSearch(search);
      if (!search) {
        return Promise.reject('No search term provided');
      }

      this.search = search;
      var url = _urls2.default.get(this.urlName, { search: search });

      if (cache.has(search)) {
        this.currentFetch = cache.get(search);
      } else {
        this.currentFetch = _evite2.default.fetch(url, {
          credentials: 'include',
          headers: {
            "X-CSRFToken": _evite2.default.cookie("csrftoken"),
            "Accept": "application/json",
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response.statusText);
        }).then(function (json) {
          return Object.assign({ search: search }, json || {});
        }).catch(function (error) {
          _evite2.default.error("Error while posting to " + url + " errorThrown=" + error);
        });
        cache.set(search, this.currentFetch);
      }

      return this.currentFetch;
    }
  }, {
    key: 'sync',
    value: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(searchOrJson) {
        var json;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                json = void 0;

                if (!(typeof searchOrJson === 'string')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.fetchSearchTerm(searchOrJson);

              case 4:
                json = _context.sent;
                _context.next = 8;
                break;

              case 7:
                json = searchOrJson;

              case 8:

                Object.assign(this, this.parse(json));
                this.categoryCollection.reset(this.categories);
                this.suggestionCollection.reset(this.suggestions);
                this.hintCollection.reset(this.hints);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sync(_x) {
        return _ref.apply(this, arguments);
      }

      return sync;
    }()
  }, {
    key: 'parse',
    value: function parse() {
      var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var parsedJson = Object.assign({}, json);

      parsedJson.search = json.search || '';
      parsedJson.status = json.status || 'unknown';

      var categories = parsedJson.categories = (json.categories || json.category || []).concat();
      var suggestions = parsedJson.suggestions = (json.suggestions || []).concat();
      var hints = parsedJson.hints = (json.hints || []).concat();

      var length = categories.length;
      for (var i = 0; i < length; ++i) {
        var categoryData = categories[i];

        var _categoryData = _slicedToArray(categoryData, 2),
            text = _categoryData[0],
            id = _categoryData[1];

        categories[i] = new SearchSuggestionModel({ id: id, text: text, type: SearchModel.TYPE_CATEGORY });
      }

      length = suggestions.length;
      for (var _i = 0; _i < length; ++_i) {
        var suggestionData = suggestions[_i];
        var text = '';
        var id = '';

        if (Array.isArray(suggestionData) && suggestionData.length > 1) {
          var _suggestionData = _slicedToArray(suggestionData, 2);

          text = _suggestionData[0];
          id = _suggestionData[1];
        } else {
          id = text = suggestionData;
        }

        suggestions[_i] = new SearchSuggestionModel({ id: id, text: text, type: SearchModel.TYPE_SUGGESTION });
      }

      length = hints.length;
      for (var _i2 = 0; _i2 < length; ++_i2) {
        var hintData = hints[_i2];

        var _hintData = _slicedToArray(hintData, 2),
            hint = _hintData[0],
            _id = _hintData[1];

        var _text = hint + ' ("' + hintId + '"?)';

        hints[_i2] = new SearchSuggestionModel({ id: _id, text: _text, type: SearchModel.TYPE_HINT });
      }

      return parsedJson;
    }
  }], [{
    key: 'normalizeSearch',
    value: function normalizeSearch(search) {
      if (memoise.has(search)) {
        return memoise.get(search);
      }

      var allWhitespaces = /\s+/g;
      var normalizedString = (search || '').trim().toLowerCase().replace(allWhitespaces, ' ');

      memoise.set(search, normalizedString);
      return normalizedString;
    }
  }]);

  return SearchModel;
}();

exports.default = SearchModel;

var SearchSuggestionModel = function SearchSuggestionModel(_ref2) {
  var id = _ref2.id,
      text = _ref2.text,
      type = _ref2.type;

  _classCallCheck(this, SearchSuggestionModel);

  this.id = id || '';
  this.type = type || '';
  this.text = text || '';
};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(58),
    isLength = __webpack_require__(60);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleMegaNavMoreLinkClick = handleMegaNavMoreLinkClick;
exports.handleMegaNavCloseLinkClick = handleMegaNavCloseLinkClick;
exports.findAncestor = findAncestor;
function handleMegaNavMoreLinkClick(e) {
  e.preventDefault();
  this.parentElement.parentElement.className += "show-all";
  return false;
};

function handleMegaNavCloseLinkClick(e) {
  e.preventDefault();
  evite.hide(findAncestor(e.target, 'mega-nav-wrapper'));
  return false;
};

function findAncestor(element, className) {
  while ((element = element.parentElement) && !element.classList.contains(className)) {}
  return element;
};

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(XDate) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SponsoredNotificationView = exports.NotificationCenterView = exports.NotificationsBadgeView = exports.NotificationView = exports.NotificationsCollection = exports.NotificationModel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _timestamp = __webpack_require__(407);

var _template = __webpack_require__(181);

var _template2 = _interopRequireDefault(_template);

var _evite = __webpack_require__(40);

var _uuid = __webpack_require__(15);

var _uuid2 = _interopRequireDefault(_uuid);

var _news = __webpack_require__(492);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOTIFICATION_CENTER_PER_USER_LIMIT = 1000;
var NOTIFICATION_CENTER_NAVBAR_LIMIT = 10;

var sponsoredNotificationItemTemplate = (0, _template2.default)('\n    <div class="notification-item sponsored">\n        <div class="sponsored-upper"><i class="icon icon-bolt"></i>Ad</div>\n        <div class="sponsored-right">\n            <a href="<%- view_details_url %>"><img src="<%- re_user_image_url %>"/></a>\n        </div>\n        <div class="sponsored-lower">\n            <a class="notification-text ui-link" href="<%- view_details_url %>"><p><%= text %></p></a>\n        </div>\n    </div>');

var notificationItemTemplate = (0, _template2.default)('\n    <div class="notify-left"><%= avatar %></div>\n    <div class="bullet-with-tooltip"><%- read_bullet %><span class="tooltiptext">Mark as <%- switch_read_state %></span></div>\n    <div class="notification-context-menu">\n        <div class="context-menu-icon"></div>\n        <div class="context-menu-items-wrapper">\n            <div class="context-menu-item">\n                <a class="hide-notification ui-link" role="button" href="javascript:void 0;">Hide this notification</a>\n            </div>\n            <div class="context-menu-item">\n                <%= event_settings_link %>\n            </div>\n        </div>\n    </div>\n    <div class="notify-center">\n        <p>\n            <a class="notification-text ui-link" href="<%- view_details_url %>"><%= text %></a>\n        </p>\n        <div class="time-label"><%- timestamp %></div>\n    </div>\n    ');

var notificationCenterTemplate = (0, _template2.default)('\n    <div class="flex-container">\n        <div id="news_item_wrapper_<%- news_item_type %>" class="news-item-wrapper <%- news_item_type %>" data-template-name="news_item_<%- news_item_type %>"></div>\n        <div class="notifications-list-header">\n            <span class="notifications-list-title">Your Evite Notifications</span>\n            <a href="javascript:void 0;" class="notifications-mark-all-as-read">Mark all as read</a>\n        </div>\n        <ul class="notifications-list"></ul>\n         <div class="notifications-list-footer">\n            <a href="/all-notifications" class="ui-link">View all notifications</a>\n        </div>\n    </div>\n');

var emptyListTemplate = (0, _template2.default)('\n    <div class="empty-notification-items-message">\n        <p>This is the very beginning of your Evite Notifications. Check here to stay up to date on all of your Evite events!</p>\n        <p>Host or RSVP to an event, and let the notifications roll in.</p>\n    </div>');

function ajax_notify_update(ids_to_update, prop, val, success_callback) {
    var error_callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    // TODO - Ask Rudy if this needs to be sent when ids_to_update is empty.
    var url = _urls2.default.get('ajax_notify_update');
    var payload = { "messages": ids_to_update };
    payload[prop] = val;
    window.evite.fetch(url, {
        method: "post",
        body: JSON.stringify(payload),
        credentials: 'include',
        cache: "no-cache",
        headers: {
            "X-CSRFToken": evite.cookie("csrftoken"),
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return response.clone().json();
    }).then(function (json) {
        success_callback(json);
    }).catch(function (error) {
        evite.error("Error while posting to " + url + " errorThrown=" + error);
        if (error_callback) {
            error_callback();
        }
    });
}

var NotificationModel = function (_Emitter) {
    _inherits(NotificationModel, _Emitter);

    function NotificationModel(obj) {
        _classCallCheck(this, NotificationModel);

        var _this = _possibleConstructorReturn(this, (NotificationModel.__proto__ || Object.getPrototypeOf(NotificationModel)).call(this));

        _this.id = null;
        _this.re_user_image_url = null;
        _this.p_text = null;
        _this.msg_type = null;
        _this.created = null;
        _this.event_id = null;
        _this.text = null;
        _this.view_details_url = null;
        _this.re_user_avatar_disk = null;
        _this.read = false;
        _this.p_context = null;
        _this.re_user_initials = null;
        _this.event_settings_url = null;
        _this.post_id = null;
        _this.re_user_id = null;
        _this.viewed = false;
        _this.collection = null;

        _this.id = _uuid2.default.v1();
        Object.assign(_this, obj);
        _this.addEventListener('change', _this.notify_collection_of_changes);
        return _this;
    }

    _createClass(NotificationModel, [{
        key: 'destroy',
        value: function destroy() {
            var _this2 = this;

            var id_to_delete = this['created'];
            ajax_notify_update(id_to_delete, "delete", true, function () {
                var event = new CustomEvent('model:destroy', { 'detail': _this2.id });
                _this2.collection.dispatchEvent(event);
            });
        }
    }, {
        key: 'notify_collection_of_changes',
        value: function notify_collection_of_changes() {
            this.dispatchEvent(new CustomEvent('collection:change'));
        }
    }, {
        key: 'created_as_date',
        get: function get() {
            var CREATED_REGEX = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.(\d{3})/;
            var match = CREATED_REGEX.exec(this.created);
            var d = new XDate();
            if (match) {
                d.setUTCFullYear(match[1], parseInt(match[2], 10) - 1, match[3]);
                d.setUTCHours(match[4], match[5], match[6], match[7]);
            }
            return d;
        }
    }]);

    return NotificationModel;
}(_evite.Emitter);

var NotificationsCollection = function (_Emitter2) {
    _inherits(NotificationsCollection, _Emitter2);

    function NotificationsCollection(options) {
        _classCallCheck(this, NotificationsCollection);

        var _this3 = _possibleConstructorReturn(this, (NotificationsCollection.__proto__ || Object.getPrototypeOf(NotificationsCollection)).call(this));
        // none of this applies if the user is not logged in, let's save ourselves some browser time


        _this3.models = [];

        _this3.removeNotification = function (e) {
            _this3.models = _this3.models.filter(function (model) {
                return model.id !== e.detail;
            });
            _this3.dispatchEvent(new CustomEvent('collection:removeModel'));
        };

        _this3.fetchNotifications = function () {
            window.evite.fetch(_urls2.default.get('ajax_notify_items'), {
                method: 'get',
                credentials: "same-origin"
            }).then(function (response) {
                return response.clone().json();
            }).then(function (data) {
                data = data || {};
                data.notifications = data.notifications || [];

                _this3.models.splice(0);
                data.notifications.forEach(function (model) {
                    var new_model = new NotificationModel(_extends({}, model, { collection: _this3 }));
                    var observed_model = (0, _evite.observe)(new_model, function (prop, val) {
                        observed_model.dispatchEvent(new CustomEvent('change'));
                    });
                    _this3.models.push(observed_model);
                });
                _this3.dispatchEvent(new CustomEvent('collection:fetch'));
                _this3.fetchCallback && _this3.fetchCallback(_this3);
                _this3.dispatchEvent(new CustomEvent('collection:news_item_fetch', { detail: data.news_item }));
            });
        };

        if (options.fetchCallback) _this3.fetchCallback = options.fetchCallback;
        _this3.addEventListener('model:destroy', _this3.removeNotification, false);
        // this.addEventListener('model:change', this.dispatchEvent(new CustomEvent('collection:change')), false);
        _this3.fetchNotifications();
        return _this3;
    }

    _createClass(NotificationsCollection, [{
        key: 'markAllAs',
        value: function markAllAs(attr) {
            var _this4 = this;

            var models_to_update = this.models.filter(function (model) {
                return model[attr] === false;
            }).map(function (model) {
                return model['created'];
            });
            ajax_notify_update(models_to_update, attr, true, function () {
                _this4.models = _this4.models.map(function (model) {
                    model[attr] = true;
                    return model;
                });
                _this4.dispatchEvent(new CustomEvent('collection:change'));
            });
        }
    }, {
        key: 'length',
        get: function get() {
            return this.models.length;
        }
    }, {
        key: 'unviewed',
        get: function get() {
            return this.models.filter(function (model) {
                return model['viewed'] === false;
            }).length;
        }
    }, {
        key: 'unread',
        get: function get() {
            return this.models.filter(function (model) {
                return model['read'] === false;
            }).length;
        }
    }]);

    return NotificationsCollection;
}(_evite.Emitter);

var NotificationsBadgeView = function NotificationsBadgeView(options) {
    var _this5 = this;

    _classCallCheck(this, NotificationsBadgeView);

    this.render = function () {
        if (_this5.collection.unviewed > 0) {
            _this5.el.innerHTML = _this5.collection.unviewed;
            _this5.el.parentNode.classList.add("badged");
        } else {
            _this5.el.innerHTML = '';
            _this5.el.parentNode.classList.remove("badged");
        }
        return _this5;
    };

    this.collection = options.collection;
    this.el = options.el;
    this.collection.addEventListener('collection:fetch', this.render, false);
    // may not need this one :
    this.collection.addEventListener('collection:change', this.render, false);
    this.collection.addEventListener('collection:removeModel', this.render, false);
    this.render();
};

var NotificationView = function () {
    function NotificationView(options) {
        var _this6 = this;

        _classCallCheck(this, NotificationView);

        this.bind_events = function () {
            _this6.model.addEventListener('change', _this6.render);
            _this6.el.querySelector('.hide-notification').addEventListener('click', _this6.hideNotification);
            _this6.el.querySelector('.bullet-with-tooltip').addEventListener('click', _this6.toggleRead);
            _this6.el.querySelector('.notification-context-menu').addEventListener('click', _this6.selectContextMenu);
            _this6.el.addEventListener('mouseenter', _this6.showContextControls);
            _this6.el.addEventListener('mouseleave', _this6.hideContextControls);
        };

        this._avatar = function () {
            var avatar_element = _this6.model.re_user_initials;
            var re_user_image_url = _this6.model.re_user_image_url;
            var re_user_avatar_disk = _this6.model.re_user_avatar_disk;
            if (_this6.model.re_user_image_url) {
                avatar_element = '<img class="profile-image" src="' + _this6.model.re_user_image_url + '"/>';
            }
            return '<div class="photo"><div class="avatar avatar-' + re_user_avatar_disk + ' small">' + avatar_element + '</div></div>';
        };

        this._event_settings_link = function () {
            if (!_this6.model.event_settings_url) {
                return "";
            }
            return '<a class="ui-link" href="' + _this6.model.event_settings_url + '">Adjust Notification settings for this event</a>';
        };

        this._rendercontext = function () {
            var timestamp = (0, _timestamp.getTimeSinceUTCDate)(_this6.model.created_as_date);
            var read_bullet = "●";
            var switch_read_state = "read";
            if (_this6.model.read) {
                read_bullet = "○";
                switch_read_state = "unread";
            }
            var extra = {
                "avatar": _this6._avatar(),
                "event_settings_link": _this6._event_settings_link(),
                "read_bullet": read_bullet,
                "switch_read_state": switch_read_state,
                "timestamp": timestamp
            };
            return Object.assign({}, _this6.model, extra);
        };

        this.render = function () {
            var context = _this6._rendercontext();
            var html = _this6.template(context);
            _this6.el.innerHTML = html;
            if (_this6.model.read) _this6.el.classList.add('was-read');
            if (!_this6.model.read && _this6.el.classList.contains('was-read')) _this6.el.classList.remove('was-read');
            if (_this6.context_controls_should_be_visible) _this6.showContextControls();
            _this6.bind_events();
        };

        this.toggleRead = function () {
            var read_new = !_this6.model.read;
            ajax_notify_update([_this6.model.created], 'read', read_new, function () {
                _this6.model.read = read_new;
            });
        };

        this.hideNotification = function (event) {
            event.preventDefault();
            _this6.model.destroy();
        };

        this.selectContextMenu = function (event) {
            if (_this6.contextMenuItemsWrapper) {
                _this6.contextMenuItemsWrapper.style.display = 'block';
            }
            if (_this6.notificationContextMenu) {
                _this6.notificationContextMenu.focus();
            }
        };

        this.hideContextMenu = function () {
            if (_this6.contextMenuItemsWrapper) {
                _this6.contextMenuItemsWrapper.style.display = 'none';
            }
        };

        this.showContextControls = function () {
            if (_this6.bulletWithTooltip) {
                _this6.bulletWithTooltip.style.visibility = 'visible';
            }
            if (_this6.notificationContextMenu) {
                _this6.notificationContextMenu.style.visibility = 'visible';
            }

            _this6.context_controls_should_be_visible = true;
        };

        this.hideContextControls = function () {
            _this6.hideContextMenu();

            if (_this6.bulletWithTooltip) {
                _this6.bulletWithTooltip.style.visibility = 'hidden';
            }
            if (_this6.notificationContextMenu) {
                _this6.notificationContextMenu.style.visibility = 'hidden';
            }

            _this6.context_controls_should_be_visible = false;
        };

        this.el = options.el;
        this.options = options;
        this.model = options.model;
        this.parent_view = options.parent_view;
        this.context_controls_should_be_visible = false;
        this.template = notificationItemTemplate;
        this.render();
        return this.el;
    }

    _createClass(NotificationView, [{
        key: 'contextMenuItemsWrapper',


        // TODO - Get from constructor options
        get: function get() {
            return this.el.querySelector('.context-menu-items-wrapper');
        }
    }, {
        key: 'notificationContextMenu',
        get: function get() {
            return this.el.querySelector('.notification-context-menu');
        }
    }, {
        key: 'bulletWithTooltip',
        get: function get() {
            return this.el.querySelector('.bullet-with-tooltip');
        }
    }]);

    return NotificationView;
}();

var SponsoredNotificationView = function () {
    function SponsoredNotificationView() {
        _classCallCheck(this, SponsoredNotificationView);
    }

    _createClass(SponsoredNotificationView, [{
        key: 'initialize',
        value: function initialize(options) {
            this.options = options;
            this.el = options.el;
            this.id = options.id;
            this.model = options.model;
            this.parent_view = this.options.parent_view;
            this.el.addEventListener('model:change-' + this.id, this.render);
        }
    }, {
        key: 'render',
        value: function render() {
            var html = this.template(this.model.attributes);
            this.el.innerHTML = html;
            return this.el;
        }
    }, {
        key: 'template',
        get: function get() {
            var template_text = this.parent_view.sponsored_notification_template;
            return (0, _template2.default)(template_text);
        }
    }]);

    return SponsoredNotificationView;
}();

var NotificationCenterView = function () {
    function NotificationCenterView(options) {
        var _this7 = this;

        _classCallCheck(this, NotificationCenterView);

        this.bind_events = function () {
            _this7.collection.addEventListener('collection:news_item_fetch', _this7.newsItemFetched, false);
            _this7.collection.addEventListener('collection:change', _this7.render, false);
            _this7.collection.addEventListener('collection:fetch', _this7.render, false);
            _this7.collection.addEventListener('collection:removeModel', _this7.render, false);

            (0, _evite.liveBind)(_this7.el, 'click', '.notifications-mark-all-as-read', _this7.markAllAsRead);

            if (_this7.options.pulldown) {
                (0, _evite.liveBind)(_this7.el, 'scroll', '.notifications-list', _this7.showShadows);
            }
        };

        this.showShadows = function (e) {
            if (_this7.notificationsListHeader) {
                if (e.currentTarget.scrollTop > 0) {
                    _this7.notificationsListHeader.classList.add('has-shadow');
                } else {
                    _this7.notificationsListHeader.classList.remove('has-shadow');
                }
            }

            if (_this7.notificationsListFooter) {
                if (e.currentTarget.scrollHeight > e.currentTarget.clientHeight) {
                    _this7.notificationsListFooter.classList.add('has-shadow');
                } else {
                    _this7.notificationsListFooter.classList.remove('has-shadow');
                }

                if (e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.clientHeight - 4) {
                    _this7.notificationsListFooter.classList.remove('has-shadow');
                }
            }
        };

        this.render = function () {
            if (_this7.notificationsContainer) {
                var context = { news_item_type: getNewsItemTypeFrom(_this7.notificationsContainer) };
                _this7.notificationsContainer.innerHTML = _this7.template(context);
            }

            if (_this7.notificationsList) {
                _this7.notificationsList.innerHTML = '';
                var has_sponsored = false;

                // Create a view for each Notification.
                _this7.collection.models.forEach(function (model) {
                    var view = null;
                    var el = document.createElement('li');
                    el.classList.add('notification-item');
                    var view_options = {
                        el: el,
                        model: model,
                        parent_view: _this7
                    };
                    if (model["msg_type"] === "sponsored") {
                        view = new SponsoredNotificationView(view_options);
                        has_sponsored = true;
                    } else {
                        view = new NotificationView(view_options);
                    }
                    _this7.notificationsList.appendChild(view);
                });

                if (_this7.collection.models.length < 1) {
                    // console.log(this.empty_notification_items_list())
                    var item = _this7.empty_notification_items_list();
                    _this7.notificationsList.innerHTML = item;
                }
            }
            if (_this7.notificationsListFooter && _this7.collection.models.length > 6) {
                _this7.notificationsListFooter.classList.add('has-shadow');
            }

            _this7.news_item_view.instantiateIn(_this7.notificationsContainer);

            return _this7;
        };

        this.markAllAsViewed = function () {
            if (_this7.collection.unviewed > 0) {
                _this7.collection.markAllAs("viewed");
            }
        };

        this.markAllAsRead = function () {
            _this7.collection.markAllAs("read");
        };

        this.newsItemFetched = function (e) {
            _this7.news_item_view.setNewsItem(e.detail);
        };

        this.options = options;
        this.el = options.el;
        this.collection = options.collection;
        this.news_item_view = new _news.NewsItemView();

        // Cache this element from the template for use later
        this.template = notificationCenterTemplate;
        this.empty_notification_items_list = emptyListTemplate;
        this.page_size = NOTIFICATION_CENTER_NAVBAR_LIMIT;
        if (this.options.nav_support !== true) {
            this.page_size = NOTIFICATION_CENTER_PER_USER_LIMIT;
        }
        this.page_index = 0;

        if (this.options.pulldown) {
            this.options.pulldown.addPulldownClickCallback(this.markAllAsViewed);
        }
        this.bind_events();

        if (this.collection.length) {
            this.render();

            if (this.options.viewing_all_notifications) {
                this.markAllAsViewed();
            }
        }
    }

    _createClass(NotificationCenterView, [{
        key: 'notificationsContainer',


        // TODO - Get from constructor options
        get: function get() {
            return this.el.querySelector('.notifications-container');
        }
    }, {
        key: 'notificationsList',
        get: function get() {
            return this.el.querySelector('.notifications-list');
        }
    }, {
        key: 'notificationsListHeader',
        get: function get() {
            return this.el.querySelector('.notifications-list-header');
        }
    }, {
        key: 'notificationsListFooter',
        get: function get() {
            return this.el.querySelector('.notifications-list-footer');
        }
    }]);

    return NotificationCenterView;
}();

function getNewsItemTypeFrom(notificationsContainer) {
    var classes = notificationsContainer.classList;
    for (var idx = 0; idx < classes.length; idx++) {
        if (classes[idx].startsWith('news-item_')) {
            return classes[idx].replace('news-item_', '');
        }
    }
    return '';
}

exports.NotificationModel = NotificationModel;
exports.NotificationsCollection = NotificationsCollection;
exports.NotificationView = NotificationView;
exports.NotificationsBadgeView = NotificationsBadgeView;
exports.NotificationCenterView = NotificationCenterView;
exports.SponsoredNotificationView = SponsoredNotificationView;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsItemView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _template = __webpack_require__(181);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NEWS_ITEM_FETCH_URL = '/ajax/news/fetch/';
var NEWS_ITEM_ID_TOKEN = '<NEWS_ITEM_ID>';
var NEWS_ITEM_DISMISS_URL = '/ajax/news/dismiss/' + NEWS_ITEM_ID_TOKEN + '/';


var newsItemDesktopTemplate = (0, _template2.default)('\n<h1>News</h1>\n<div class="news-item" data-news-item-id="<%= id %>">\n  <div class="news-content">\n    <a class="news_item_dismiss" href=\'javascript:void 0;\'><i class="icon-cancel"></i></a>\n    <h2 class="news_item_headline"><%= title %></h2>\n    <p class="news_item_content"><%= description %></p>\n    <div class="button_holder">\n      <a href=\'<%= link_url %>\' class=\'btn button-primary-inverse small link_button news-button\' target=\'_blank\'><%= link_text %></a>\n    </div>\n  </div>\n</div>\n');

var newsItemMobileAndNavTemplate = (0, _template2.default)('\n<h1>News</h1>\n<div class="news-item" data-news-item-id="<%= id %>">\n  <div class="news-content">\n    <a class="news_item_dismiss" href=\'javascript:void 0;\'><i class="icon-cancel"></i></a>\n    <h2 class="news_item_headline"><%= title %></h2>\n    <p class="news_item_content"><%= description %></p>\n    <div class="button_holder">\n      <a href=\'<%= link_url %>\' class=\'btn button-primary-inverse small link_button news-button\' target=\'_blank\'><%= link_text %></a>\n    </div>\n  </div>\n</div>\n');

var templatesByName = {
  news_item_desktop: newsItemDesktopTemplate,
  news_item_mobile: newsItemMobileAndNavTemplate,
  news_item_nav: newsItemMobileAndNavTemplate
};

// Displays the news item, if there is one, in the top part of the notification
// center.

var NewsItemView = function () {
  function NewsItemView() {
    _classCallCheck(this, NewsItemView);

    this.renderedHtml = null;
    this.containerDiv = null;
    this.dismissUrl = '';
  }

  _createClass(NewsItemView, [{
    key: 'instantiateIn',
    value: function instantiateIn(notificationsContainerElem) {
      this.containerDiv = notificationsContainerElem.querySelector('.news-item-wrapper');
      this._render();
    }
  }, {
    key: 'setNewsItem',
    value: function setNewsItem(newsItemData) {
      if (!newsItemData) {
        this.renderedHtml = '';
      } else {
        var templateName = this.containerDiv.dataset['templateName'];
        this.renderedHtml = this._newsItemDataToHTML(newsItemData, templateName);
      }
      this._render();
    }
  }, {
    key: '_newsItemDataToHTML',
    value: function _newsItemDataToHTML(newsItemData, templateName) {
      var compiledTemplate = templatesByName[templateName];
      if (!compiledTemplate) {
        return '';
      }
      return compiledTemplate(newsItemData);
    }
  }, {
    key: '_render',
    value: function _render() {
      if (this.renderedHtml === null || this.containerDiv === null) {
        return; // not ready to render
      }

      this.containerDiv.innerHTML = this.renderedHtml;
      if (this.renderedHtml) {
        var newsItemId = this.containerDiv.querySelector('div.news-item').dataset['newsItemId'];
        var dismissLink = this.containerDiv.querySelector('.news_item_dismiss');
        this.dismissUrl = NEWS_ITEM_DISMISS_URL.replace(NEWS_ITEM_ID_TOKEN, newsItemId);
        var boundDismissClickedFcn = this._handleDismissedClicked.bind(this);
        evite.when('jquery').then(function () {
          dismissLink.addEventListener('click', boundDismissClickedFcn);
        });
      }
    }
  }, {
    key: '_handleDismissedClicked',
    value: function _handleDismissedClicked(e) {
      e.preventDefault();

      window.evite.fetch(this.dismissUrl, {
        method: 'get',
        credentials: "same-origin"
      });

      // animate the closing - shrink the height and fade to nearly transparent
      // first fix the width and height to the current width/height
      var containerDiv = $(this.containerDiv);
      containerDiv.css({
        width: containerDiv.outerWidth(),
        height: containerDiv.outerHeight()
      });
      containerDiv.animate({
        opacity: 0.25,
        height: "toggle"
      }, {
        duration: 300,
        complete: function complete() {
          containerDiv.hide();
        }
      });

      // blank out the html so it doesn't come back in case _render() gets called again
      this.renderedHtml = '';
    }
  }]);

  return NewsItemView;
}();

;

exports.NewsItemView = NewsItemView;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _evite = __webpack_require__(40);

var _index = __webpack_require__(1);

var _urls = __webpack_require__(0);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignInView = function (_Emitter) {
    _inherits(SignInView, _Emitter);

    function SignInView() {
        _classCallCheck(this, SignInView);

        var _this = _possibleConstructorReturn(this, (SignInView.__proto__ || Object.getPrototypeOf(SignInView)).call(this));

        _this.user = null;
        _this.signed_in = false;

        _this.el = document.getElementById('header');
        _this.signed_in = _this.check_signed_in();
        _this.bindEvents();
        return _this;
    }

    _createClass(SignInView, [{
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _evite.liveBind)(this.el, 'click', '#signin_button', this.sign_in);
            (0, _evite.liveBind)(this.el, 'click', '#signout_button', this.sign_out);
            (0, _evite.liveBind)(this.el, 'click', '#register_button', this.register);
        }
    }, {
        key: 'get_user',
        value: function get_user() {
            // evite_cookie = window.evite.cookie('x-evite-auth')
            // evite_cookie && evite_cookie.split(':')[0]
            // doh, the auth cookie changed and we need some way to keep this functionality
            return window.tags.dl.email;
        }
    }, {
        key: 'check_signed_in',
        value: function check_signed_in() {
            var r = 0;
            try {
                r = window.tags.dl.is_logged_in === 1;
            } finally {
                return r;
            }
        }
    }, {
        key: 'get_next',
        value: function get_next() {
            // for sign in and register, return the 'next' param if appropriate
            if (window.location.protocol === 'https:') {
                return getURLParameter('next');
            }

            if (!window.location.pathname.match(/(login|register).*/)) {
                var n = window.location.pathname;
                if (window.location.search) {
                    n += window.location.search;
                }
                return n;
            }
            return null;
        }
    }, {
        key: 'sign_in',
        value: function sign_in(callback, next) {
            var _this2 = this;

            if (!next) {
                next = null;
            }
            if (typeof callback !== 'function') {
                callback = null;
            }
            if (callback === null) {
                next = next || this.get_next() || '';
                if (next) {
                    next = '?next=' + encodeURIComponent(next);
                }
                window.location.href = _urls2.default.get('login') + next;
                return;
            }
            var sign_in_modal = new _index.AuthModal({
                onLogin: function onLogin(r) {
                    window.tags.track_event('on_login');
                    if (callback != null) {
                        _this2.set_signed_in_state(r.full_name);
                        return callback();
                    } else {
                        return _this2.set_signed_in(r.full_name);
                    }
                },
                onCancel: function onCancel() {
                    return _this2.dispatchEvent(new CustomEvent('cancel'));
                }
            });
            return sign_in_modal.show();
        }
    }, {
        key: 'register',
        value: function register(callback, next) {
            var _this3 = this;

            var register_modal = void 0;
            if (!next) {
                next = null;
            }
            if (typeof callback !== 'function') {
                callback = null;
            }
            if (callback === null) {
                next = next || this.get_next() || '';
                if (next) {
                    next = '?next=' + encodeURIComponent(next);
                }
                window.location.href = _urls2.default.get('register') + next;
                return;
            }
            register_modal = new _index.AuthModal({
                url: _urls2.default.get('register_modal'),
                onLogin: function onLogin(d) {
                    return _this3.set_signed_in(d.full_name);
                }
            });
            return register_modal.show();
        }
    }, {
        key: 'sign_out',
        value: function sign_out() {
            window.tags.page_event('signout_button');
            window.evite.fetch(_urls2.default.get('ajax_logout'), {
                method: "post",
                credentials: 'include',
                headers: {
                    "X-CSRFToken": evite.cookie("csrftoken"),
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                return window.location.assign(_urls2.default.get('login'));
            }).catch(function (error) {
                evite.error("Error while posting to " + url + " errorThrown=" + error);
            });
        }
    }, {
        key: 'set_signed_in_state',
        value: function set_signed_in_state(full_name) {
            var loggedIn = document.querySelector('.logged_in');
            var signedIn = document.querySelector('.signed_in');
            var loggedOut = document.querySelector('.logged_out');
            var signedOut = document.querySelector('.signed_out');
            var signIn = document.querySelector('.signin');
            var name = document.querySelector('li.user .full_name');
            if (loggedIn) loggedIn.style.display = 'block';
            if (signedIn) loggedIn.style.display = 'block';
            if (loggedOut) loggedIn.style.display = 'none';
            if (signedOut) loggedIn.style.display = 'none';
            if (signIn) loggedIn.style.display = 'none';
            this.signed_in = true;
            this.user = full_name;
            if (name) name.innerHTML = full_name;
            return this.dispatchEvent(new CustomEvent('success'));
        }
    }, {
        key: 'set_signed_in',
        value: function set_signed_in(full_name) {
            if (!window.prevent_page_reload_on_login) {
                return window.location.reload();
            } else {
                return this.set_signed_in_state(full_name);
            }
        }
    }, {
        key: 'facebook_connect',
        value: function facebook_connect(opts) {
            var _this4 = this;

            window.tags.page_event('facebook_connect');

            var w = 580;
            var h = 400;
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            var popup = window.open(_urls2.default.get('facebook_connect'), 'fb_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
            if (popup == null) {
                if (!window.prevent_page_reload_on_login) {
                    window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
                } else {
                    alert("We tried to open a popup window to connect to Facebook. Please enable popup windows in your browser.");
                }
                return;
            }

            var check_connected = function check_connected() {
                if (popup.closed) {
                    var _url = _urls2.default.get('ajax_authenticated');
                    window.evite.fetch(_url, {
                        credentials: 'include',
                        headers: {
                            "X-CSRFToken": evite.cookie("csrftoken"),
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        }
                    }).then(function (response) {
                        return response.json();
                    }).then(function (data) {
                        if (data && data.full_name) {
                            _this4.set_signed_in(data.full_name);
                            if (opts.onConnect) {
                                return opts.onConnect(data.full_name);
                            }
                        }
                    }).catch(function (error) {
                        window.console.log("Error while posting to " + _url + " errorThrown=" + error);
                    });
                } else {
                    return setTimeout(check_connected, 300);
                }
            };

            return check_connected();
        }
    }, {
        key: 'google_plus_connect',
        value: function google_plus_connect(opts) {
            var _this5 = this;

            window.tags.page_event('google_plus_connect');

            var w = 580;
            var h = 400;
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            var popup = window.open(_urls2.default.get('google_plus_connect'), 'gp_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
            if (popup == null) {
                if (!window.prevent_page_reload_on_login) {
                    window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
                } else {
                    alert("We tried to open a popup window to connect to Google Plus. Please enable popup windows in your browser.");
                }
                return;
            }

            var check_connected = function check_connected() {
                if (popup.closed) {
                    window.evite.fetch(_urls2.default.get('ajax_authenticated'), {
                        credentials: 'include',
                        headers: {
                            "X-CSRFToken": evite.cookie("csrftoken"),
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        }
                    }).then(function (response) {
                        return response.json();
                    }).then(function (data) {
                        if (data && data.full_name) {
                            _this5.set_signed_in(data.full_name);
                            if (opts.onConnect) {
                                opts.onConnect(data.full_name);
                            }
                        }
                    }).catch(function (error) {
                        if (window.console !== null) {
                            console.log('error: ' + error);
                        }
                    });
                } else {
                    return setTimeout(check_connected, 300);
                }
            };

            return check_connected();
        }
    }]);

    return SignInView;
}(_evite.Emitter);

;

exports.default = SignInView;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(5);

var _evite = __webpack_require__(40);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO - refactor (seems only site_warning is used)
var HeaderNavView = function () {
    function HeaderNavView() {
        _classCallCheck(this, HeaderNavView);

        this.run_search = function (event) {
            event.target.closest('form').submit();
        };

        this.el = document.querySelector('body');
        (0, _evite.liveBind)(this.el, 'touchstart', '#searchIcon', this.run_search);
        (0, _evite.liveBind)(this.el, 'click', '#searchIcon', this.run_search);
    }

    _createClass(HeaderNavView, [{
        key: 'site_warning',
        value: function site_warning(message) {
            var div = document.createElement('div');
            div.classList.add('site-warning');
            div.innerHTML = message;
            (0, _utils.insertAfter)(div, document.getElementById('header').firstChild);
        }
    }]);

    return HeaderNavView;
}();

exports.default = HeaderNavView;
;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _timer = __webpack_require__(189);

var _timer2 = _interopRequireDefault(_timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var openMenus = [];

var PulldownMenu = function () {
    _createClass(PulldownMenu, null, [{
        key: 'hideOpenMenus',
        value: function hideOpenMenus() {
            while (openMenus.length) {
                openMenus.pop().hideMenu();
            }
        }
    }]);

    function PulldownMenu(options) {
        var _this = this;

        _classCallCheck(this, PulldownMenu);

        this.enabled = true;
        this.open = false;
        this.externalClickCallback = evite.noop;

        this.setEnabled = function (enabled) {
            _this.enabled = enabled;
            if (!enabled) {
                _this.hideMenu();
            }
        };

        this.hideMenu = function () {
            if (!_this.open) {
                return;
            }

            _this.open = false;
            _this.hideMenuTimer.stop();
            _this.menu.classList.add('hidden');
        };

        this.showMenu = function () {
            if (_this.open || !_this.enabled) {
                return;
            }

            _this.hideMenuTimer.stop();
            _this.menu.classList.remove('hidden');
            _this.open = true;

            if (openMenus.indexOf(_this) === -1) {
                openMenus.push(_this);
            }
        };

        this.addPulldownClickCallback = function (callback) {
            _this.externalClickCallback = callback || evite.noop;
        };

        this.handlePulldownClickOnMobile = function (event) {
            _this.externalClickCallback();
        };

        this.handlePulldownMouseEnter = function (event) {
            event.stopPropagation();
            if (_this.open) {
                openMenus.splice(openMenus.indexOf(_this), 1);
            }

            PulldownMenu.hideOpenMenus();
            if (_this.open) {
                openMenus.push(_this);
            } else {
                _this.showMenu();
            }

            _this.externalClickCallback();
        };

        this.handleFocusout = function (event) {
            if (_this.open && !_this.hideMenuTimer.isRunning) {
                _this.hideMenuTimer.start();
            }
        };

        this.handleMouseMove = function (event) {
            if (_this.hideMenuTimer.isRunning) {
                _this.hideMenuTimer.stop();
            }
        };

        this.stopEventPropagation = function (event) {
            event.stopPropagation();
        };

        this.el = evite.assert(options.el);
        this.pulldown = this.el.querySelector('.pulldown-link');
        this.hideMenuTimer = new _timer2.default(250, Number.POSITIVE_INFINITY);

        this.hideMenuTimer.on(_timer2.default.TICK, this.hideMenu);

        if (evite.detects.isDesktop) {
            this.pulldown.addEventListener("mouseenter", this.handlePulldownMouseEnter);
            this.el.addEventListener('mousemove', this.handleMouseMove);
            this.el.addEventListener("mouseenter", this.stopEventPropagation);
            this.el.addEventListener("mouseover", this.stopEventPropagation);

            document.body.addEventListener('mouseover', this.handleFocusout);
        } else {
            this.pulldown.addEventListener("click", this.handlePulldownClickOnMobile);
        }
    }

    _createClass(PulldownMenu, [{
        key: 'menu',
        get: function get() {
            return this.el.querySelector('.menu');
        }
    }]);

    return PulldownMenu;
}();

exports.default = PulldownMenu;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _screen = __webpack_require__(497);

var _screen2 = _interopRequireDefault(_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clamp() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var value = params.value,
        min = params.min,
        max = params.max;

    return Math.min(Math.max(value, min), max);
}

var map = Array.prototype.map;


var fixHeader = function fixHeader() {
    var _context;

    var $header = document.getElementById("header");
    var $template = document.getElementById('design-template');
    var $ads = (_context = document.querySelectorAll("#ad-north-rsvp, #ad_mobile_top, #header"), map).call(_context, function (el) {
        return el.parentNode;
    });
    var $navContainer = document.querySelector('.nav-container');
    var $actionBar = document.querySelector('.action-bar');
    var $fullPreviewBar = document.querySelector("#full_preview_bar");
    var navTop = 0;

    // only call handleScroll() if header is not sticky
    if (!evite.experiments.inExperiment('sticky_header')) {
        document.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    function handleScroll() {
        if (!$header) {
            return;
        }
        var headerMarginTop = 0;
        var scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        if (!_screen2.default.isSmall()) {
            headerMarginTop = calculateHeaderMarginTop(scrollTop);
        }
        $header.style.marginTop = headerMarginTop + "px";
        navTop = scrollTop + headerMarginTop;
    }

    function calculateHeaderMarginTop(scrollTop) {
        var templateHeight = $template ? $template.clientHeight : 0;
        var actionBarHeight = $actionBar ? $actionBar.clientHeight : 0;
        var navHeight = $navContainer ? $navContainer.clientHeight : 0;
        var fadeBoundary = $actionBar ? templateHeight - actionBarHeight : templateHeight - navHeight;
        var adTop = $actionBar ? Math.max(0, fadeBoundary) : Math.max(0, fadeBoundary + navHeight);

        if (scrollTop <= adTop) {
            return 0;
        }

        var inverseNavSize = -1 * $header.clientHeight;

        if (window.cookie_dismissed) {
            window.cookie_dismissed = false;
            inverseNavSize = inverseNavSize + 30;
        }

        var isBetweenAdTopAndSubNav = scrollTop > adTop && scrollTop < adTop - inverseNavSize;
        var isBetweenNavBoundaryAndSubNav = scrollTop < navTop && scrollTop < navTop - inverseNavSize;

        if (isBetweenAdTopAndSubNav && isBetweenNavBoundaryAndSubNav) {
            return clamp({ value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: 0 });
        } else if (_screen2.default.isLarge() && isBetweenAdTopAndSubNav) {
            return clamp({ value: adTop - scrollTop, min: inverseNavSize, max: 0 });
        } else if (_screen2.default.isMedium()) {
            return clamp({ value: adTop - scrollTop, min: inverseNavSize + navHeight, max: 0 });
        }

        var adMargin = $ads.length ? -1 * $header.clientHeight : -50;

        if ($fullPreviewBar) {
            adMargin -= $fullPreviewBar.clientHeight;
        }

        if (isBetweenNavBoundaryAndSubNav) {
            return clamp({ value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: adMargin });
        }

        return inverseNavSize;
    }
};

exports.default = fixHeader;

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SMALL_BREAK_POINT = exports.SMALL_BREAK_POINT = 500;
var MEDIUM_BREAKPOINT = exports.MEDIUM_BREAKPOINT = 768;

var docElement = document.documentElement;
var docBody = document.body;

var screenWidth = 0;
var screenHeight = 0;
var screenMinSize = 0;
var screenMaxSize = 0;

exports.default = {
    isSmall: function isSmall() {
        return screenMinSize <= SMALL_BREAK_POINT;
    },
    isMedium: function isMedium() {
        return screenMinSize > SMALL_BREAK_POINT && screenMinSize <= MEDIUM_BREAKPOINT;
    },
    isLarge: function isLarge() {
        return screenMinSize > MEDIUM_BREAKPOINT;
    }
};


function handleResize() {
    screenWidth = window.screen && window.screen.width || window.innerWidth || docElement && docElement.clientWidth || docBody.clientWidth || 0;
    screenHeight = window.screen && window.screen.height || window.innerHeight || docElement && docElement.clientHeight || docBody.clientHeight || 0;

    screenMinSize = Math.min(screenWidth, screenHeight);
    screenMaxSize = Math.max(screenWidth, screenHeight);
}

$(window).resize(handleResize);
handleResize();

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ajax_csrf_setup = undefined;

var _evite = __webpack_require__(182);

var _evite2 = _interopRequireDefault(_evite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ajax_csrf_setup() {
    evite.when('jquery').then(function () {
        var csrfSafeMethod = function csrfSafeMethod(method) {
            return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
            );
        };
        var csrf_token = (0, _evite2.default)('csrftoken');
        $.ajaxSetup({
            beforeSend: function beforeSend(xhr, settings) {
                if (!csrfSafeMethod(settings.type)) {
                    return xhr.setRequestHeader("X-CSRFToken", csrf_token);
                }
            }
        });
    });
}

exports.ajax_csrf_setup = ajax_csrf_setup;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.card_height = card_height;
exports.pluralize = pluralize;
exports.insertAfter = insertAfter;
exports.insertBefore = insertBefore;
exports.htmlFromString = htmlFromString;
exports.isEmpty = isEmpty;
exports.popup_window = popup_window;
exports.configure_selectboxes = configure_selectboxes;
exports.valid_email = valid_email;
exports.guest_valid_email = guest_valid_email;
exports.parse_us_phone_number = parse_us_phone_number;
exports.normalize_phone_number = normalize_phone_number;
exports._get_digits_from = _get_digits_from;
exports.pretty_format_phone_number = pretty_format_phone_number;
exports.getURLParameter = getURLParameter;
exports.parseParams = parseParams;
exports.stringifyParams = stringifyParams;
function card_height(class_name) {
    var height = 400;
    switch (class_name) {
        case 'panel':
            height = 475;
            break;
        case 'postcard':
            height = 555;
            break;
        case 'full':
            height = 555;
            break;
        case 'big_and_tall':
            height = 735;
    }
    return height + 'px';
};

function pluralize(label, count) {
    label = count === 1 ? label : label + 's';
    return count + ' ' + label;
}

function insertAfter(newNode, node) {
    node.parentNode.insertBefore(newNode, node.nextSibling);
}

function insertBefore(newNode, node) {
    node.parentNode.insertBefore(newNode, node);
}

function htmlFromString(string) {
    var div = document.createElement('div');
    div.innerHTML = string;
    return div.firstChild;
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

function popup_window(loc, width, height, resizable, scrollbars, toolbar, dependent, window_name, location_bar, status_bar, align) {
    var left_position = 1;
    var top_position = 1;

    if (align === "center") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = screen.height ? (screen.height - height) / 2 : 0;
    } else if (align === "topright") {
        left_position = screen.width ? screen.width - width : 0;
        top_position = 1;
    } else if (align === "topcenter") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = 1;
    }

    var align_value = 'top=' + top_position + ',left=' + left_position;
    var win = eval("window.open(loc, '${window_name}','width=${width},height=${height},resizable=${resizable},scrollbars=" + scrollbars + ",toolbar=" + toolbar + ",dependent=" + dependent + ",screenX=1,screenY=1,${align_value},location=${location_bar},status=${status_bar}')");
    win.focus();
};

function configure_selectboxes() {
    function toggle_unselected_style(target) {
        var _selectbox = $(target);
        if (!_selectbox || _selectbox.val() === '' || !_selectbox.val()) {
            $(_selectbox).addClass('unselected');
        } else {
            $(_selectbox).removeClass('unselected');
        }
    };

    var selectboxes = $('.select-holder select');
    selectboxes.each(function (index, selectbox) {
        toggle_unselected_style(selectbox);

        $(selectbox).change(function (e) {
            toggle_unselected_style(e.currentTarget);
        });
    });
};

/**
 * valid_email(email)
 *
 * - says whether the provided email address is valid or not, and if not,
 *   why
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      error_code: <string>
 *      error_message: <string>
 *   }
 *  - possible error codes (strings):
 *    - 'email_empty'
 *    - 'email_invalid'
 *    - 'email_too_long'
 *  - callers can use those error codes to provide their own,
 *    context-specific error messaging
 *
 **/
function valid_email(email) {
    if (!Boolean(email)) {
        return { is_valid: false, error_code: 'email_empty', error_message: 'The email address is empty.' };
    }

    var email_invalid_message = 'The email address is invalid.';
    var ret_email_invalid = { is_valid: false, error_code: 'email_invalid', error_message: email_invalid_message };

    // W3C HTML5 Validation
    if (!/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(email)) {
        return ret_email_invalid;
    }

    // can't start with a dash
    if (/^\-/i.test(email)) {
        return ret_email_invalid;
    }

    // require a tld
    if (email.split('@')[1].split('.').length < 2) {
        return ret_email_invalid;
    }

    if (email.length > 320) {
        return { is_valid: false, error_code: 'email_too_long', error_message: 'The email address too long. Max length is 320 characters.' };
    }

    return { is_valid: true, error_code: '', error_message: '' };
}

// specialized version of valid_email, above, for guest emails - returns
// a 2-element array of [<is_valid>, <error_message>]
function guest_valid_email(email) {
    var email_invalid_messages = {
        email_empty: 'Please include an email for this guest.',
        email_invalid: 'Please provide a valid email address.',
        email_too_long: 'Email too long. Max length is 320 characters.',
        '': '' // for when there's no error
    };
    var validity = valid_email(email);
    return [validity.is_valid, email_invalid_messages[validity.error_code]];
}

/**
 * parse_us_phone_number(phone_number_text)
 *
 * (also works for canadian phone numbers)
 *
 * - pulls out a 10-digit number sequence (string) from the text entered,
 *   if possible
 * - if an 11-digit sequence is found and the first is a 1 (old school
 *   for "long distance"), the first digit (1) is discarded
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      formatted: <string>
 *      digits: <string>
 *   }
 *
 * Examples:
 * - parse_us_phone_number('  310.123-4567 ') returns:
 *   {
 *      "is_valid": true,
 *      "formatted": "(310) 123-4567",
 *      "digits": "3101234567"
 *   }
 * - parse_us_phone_number('3456 tom ugh') returns:
 *   {
 *      "is_valid": false,
 *      "formatted": "",
 *      "digits": "3456"
 *   }
 *
 **/
function parse_us_phone_number(phone_number_text) {
    var digits = _get_digits_from(phone_number_text);
    var is_standard_length = digits.length === 10;
    var is_1_prefixed_standard_length = digits.length === 11 && digits.charAt(0) === '1';
    if (!(is_standard_length || is_1_prefixed_standard_length)) {
        return {
            is_valid: false,
            formatted: '',
            digits: digits
        };
    }
    if (is_1_prefixed_standard_length) {
        digits = digits.slice(1, 11); // toss the leading 1
    }
    // TODO should this also make sure a 10-digit digit sequence is a valid
    // phone number, or is that overkill?
    return {
        is_valid: true,
        formatted: _format_to_us_phone_number(digits),
        digits: digits
    };
}

function normalize_phone_number(phone_number_string) {
    // Returns the original string if it doesn't validate
    var parsed = parse_us_phone_number(phone_number_string);
    if (parsed.is_valid) return "+1" + parsed.digits;
    return phone_number_string;
}

// return just the digit characters from the given string
function _get_digits_from(string_with_digits) {
    var allDigitChars = string_with_digits.match(/\d+/g) || [];
    return allDigitChars.join('');
}

function pretty_format_phone_number(phone_digits_string) {
    // Returns a pretty formatted phone number, or the original if it is not a normalized phone number
    if (!phone_digits_string) return phone_digits_string;
    var digits = phone_digits_string.trim();
    if (digits[0] === '+') digits = digits.slice(1);
    if (digits[0] === '1' && digits.length === 11) digits = digits.slice(1);
    if (digits.match(/\D/) || digits.length !== 10)
        // Not a proper phone number, so return the original string
        return phone_digits_string;
    return _format_to_us_phone_number(digits);
}

// Ex: "3101234567" ==> "(310) 123-4567"
function _format_to_us_phone_number(digits) {
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + "-" + digits.slice(6, 10);
}

function getURLParameter(name) {
    // mocks
    var search = window.mock_location_search || window.location.search;
    var matches = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(search) || [null, ''];
    var data = decodeURIComponent(matches[1].replace(/\+/g, '%20'));
    if (data) return data;
    return null;
}

/**
 * stolen from the plugin jquery.parseParams
 *
 * @param query the url query (minus the ?)
 * @returns object of url parameters
 */
function parseParams(query) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function decode(str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };

    var params = {},
        e = void 0;
    while (e = re.exec(query)) {
        var k = decode(e[1]),
            v = decode(e[2]);
        if (k.substring(k.length - 2) === '[]') {
            k = k.substring(0, k.length - 2);
            (params[k] || (params[k] = [])).push(v);
        } else params[k] = v;
    }
    return params;
}

function stringifyParams(params) {
    var paramList = [];
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var value = encodeURIComponent(params[key]);
            paramList.push(key + '=' + value);
        }
    }

    paramList.sort();

    return paramList.join('&');
}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(57);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(99);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(28),
    isObject = __webpack_require__(33);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 59:
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(484);


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(48),
    isArrayLike = __webpack_require__(49),
    isIndex = __webpack_require__(61),
    isObject = __webpack_require__(33);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {
  modal: '.evite-modal-container',
  modalInner: '.modal-inner',
  modalContent: '.modal-content',
  open: '[data-modal-open]',
  close: '[data-modal-close]',
  dataAttribute: 'data-current-modal',
  page: 'body',
  class: 'modal-visible',
  loadClass: 'evite-modal',
  clickOutside: true,
  closeKeys: [27],
  transitions: true,
  transitionEnd: null,
  onBeforeOpen: null,
  onBeforeClose: null,
  onOpen: null,
  onClose: null,
  allowClose: true
};

function throwError(message) {
  // eslint-disable-next-line no-console
  console.error('ModalView: ' + message);
}

function find(arr, callback) {
  return function (key) {
    var filteredArray = arr.filter(callback);
    return filteredArray[0] ? filteredArray[0][key] : undefined;
  };
}

function transitionEndVendorSniff() {
  var el = document.createElement('div');
  var transitions = [{ key: 'transition', value: 'transitionend' }, { key: 'OTransition', value: 'otransitionend' }, { key: 'MozTransition', value: 'transitionend' }, { key: 'WebkitTransition', value: 'webkitTransitionEnd' }];
  return find(transitions, function (_ref) {
    var key = _ref.key;
    return typeof el.style[key] !== 'undefined';
  })('value');
}

function isPopulatedArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]' && arr.length;
}

function getNode(selector, parent) {
  var targetNode = parent || document;
  var node = targetNode.querySelector(selector);
  if (!node) {
    throwError(selector + ' not found in document.');
  }
  return node;
}

function addClass(el, className) {
  if (!(el instanceof HTMLElement)) {
    throwError('Not a valid HTML element.');
  }
  el.setAttribute('class', el.className.split(' ').filter(function (cn) {
    return cn !== className;
  }).concat(className).join(' '));
}

function removeClass(el, className) {
  if (!(el instanceof HTMLElement)) {
    throwError('Not a valid HTML element.');
  }
  el.setAttribute('class', el.className.split(' ').filter(function (cn) {
    return cn !== className;
  }).join(' '));
}

function getElementContext(e) {
  if (e && typeof e.hash === 'string') {
    return document.querySelector(e.hash);
  } else if (typeof e === 'string') {
    return document.querySelector(e);
  }
  throwError('No selector supplied to open()');
  return null;
}

function applyModalSettings(settings) {
  return _extends({}, defaults, settings, {
    transitionEnd: transitionEndVendorSniff()
  });
}

function matches(e, selector) {
  var allMatches = (e.target.document || e.target.ownerDocument).querySelectorAll(selector);
  for (var i = 0; i < allMatches.length; i += 1) {
    var node = e.target;
    while (node && node !== document.body) {
      if (node === allMatches[i]) {
        return node;
      }
      node = node.parentNode;
    }
  }
  return null;
}

var ModalBase = function () {
  function ModalBase(options) {
    var _this = this;

    _classCallCheck(this, ModalBase);

    this.currentInstance = null;
    this.parser = null;
    this.openCloseQueue = null;

    this.closeTransitionHandler = function (e) {
      if (_this.resolveTransition) {
        _this.resolveTransition(_this.closeModal(e));
        _this.resolveTransition = null;
      }
    };

    if (options && options.loader) {
      if (!window.EviteLoadingModal) {
        window.EviteLoadingModal = this;
      } else {
        return window.EviteLoadingModal;
      }
    } else {
      if (!window.EviteModal) {
        window.EviteModal = this;
      } else {
        return window.EviteModal;
      }
    }

    this.parser = new DOMParser();
    this.openCloseQueue = Promise.resolve();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeKeyHandler = this.closeKeyHandler.bind(this);
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
    this.delegateOpen = this.delegateOpen.bind(this);
    this.delegateClose = this.delegateClose.bind(this);
    this.listen = this.listen.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  _createClass(ModalBase, [{
    key: 'initialize',
    value: function initialize(modalInstance) {
      this.current = null;

      this.settings = applyModalSettings(modalInstance.settings);
      this.dom = this.getDomNodes();
      this.currentInstance = modalInstance;

      this.addLoadedCssClass();
      this.listen();
    }
  }, {
    key: 'getDomNodes',
    value: function getDomNodes() {
      var _settings = this.settings,
          modal = _settings.modal,
          page = _settings.page,
          modalInner = _settings.modalInner,
          modalContent = _settings.modalContent;

      return {
        modal: getNode(modal),
        page: getNode(page),
        modalInner: getNode(modalInner, getNode(modal)),
        modalContent: getNode(modalContent, getNode(modal))
      };
    }
  }, {
    key: 'addLoadedCssClass',
    value: function addLoadedCssClass() {
      addClass(this.dom.page, this.settings.loadClass);
    }
  }, {
    key: 'setOpenId',
    value: function setOpenId(id) {
      var page = this.dom.page;

      page.setAttribute(this.settings.dataAttribute, id || 'anonymous');
    }
  }, {
    key: 'removeOpenId',
    value: function removeOpenId() {
      var page = this.dom.page;

      page.removeAttribute(this.settings.dataAttribute);
    }
  }, {
    key: 'open',
    value: function open(allMatches, e) {
      var _this2 = this;

      return this.openCloseQueue.then(function () {
        // Try to blur any active elements before opening modal
        if (document.activeElement) document.activeElement.blur();

        var _dom = _this2.dom,
            page = _dom.page,
            modalContent = _dom.modalContent;
        var _settings2 = _this2.settings,
            onBeforeOpen = _settings2.onBeforeOpen,
            onOpen = _settings2.onOpen;

        if (!(_this2.current instanceof HTMLElement === false)) {
          throwError('ModalView target must exist on page.');
          return;
        }
        if (_this2.current) _this2.releaseNode(_this2.current);
        _this2.current = getElementContext(allMatches);
        if (!_this2.settings.allowClose) {
          getNode(_this2.settings.close).style.display = 'none';
        }
        if (typeof onBeforeOpen === 'function') {
          onBeforeOpen.call(_this2, e);
        }
        _this2.captureNode(_this2.current);
        _this2.setOpenId(_this2.current.id);
        _this2.isOpen = true;
        addClass(page, _this2.settings.class);

        // set focus on last input element or anchor in the modal EVT-10809
        var lastInput = Array.from(modalContent.querySelectorAll('input, button, a')).pop();
        if (lastInput) lastInput.focus();

        if (typeof onOpen === 'function') {
          onOpen.call(_this2, e);
        }
      });
    }
  }, {
    key: 'detectTransition',
    value: function detectTransition() {
      var modal = this.dom.modal;

      var css = window.getComputedStyle(modal, null);
      return Boolean(['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'].filter(function (i) {
        return typeof css[i] === 'string' && parseFloat(css[i]) > 0;
      }).length);
    }
  }, {
    key: 'close',
    value: function close(e) {
      var _this3 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          var _settings3 = _this3.settings,
              transitions = _settings3.transitions,
              transitionEnd = _settings3.transitionEnd,
              onBeforeClose = _settings3.onBeforeClose;

          var hasTransition = _this3.detectTransition();
          if (_this3.isOpen) {
            if (typeof onBeforeClose === 'function') {
              onBeforeClose.call(_this3, e);
            }
            if (transitions && transitionEnd && hasTransition) {
              _this3.closeModalWithTransition(e).then(resolve);
            } else {
              _this3.closeModal(e).then(resolve);
            }
            removeClass(_this3.dom.page, _this3.settings.class);
          } else {
            resolve();
          }
        });
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(e) {
      var _this4 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          var onClose = _this4.settings.onClose;

          _this4.removeOpenId(_this4.dom.page);
          _this4.releaseNode(_this4.current);
          if (typeof onClose === 'function') {
            onClose.call(_this4, e);
          }
          _this4.current = null;
          _this4.isOpen = false;
          resolve();
        });
      });
    }
  }, {
    key: 'closeModalWithTransition',
    value: function closeModalWithTransition(e) {
      var _this5 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          _this5.resolveTransition = resolve;
        });
      });
    }
  }, {
    key: 'captureNode',
    value: function captureNode(node) {
      var modalContent = this.dom.modalContent;

      while (node.childNodes.length) {
        modalContent.appendChild(node.childNodes[0]);
      }
    }
  }, {
    key: 'releaseNode',
    value: function releaseNode(node) {
      var modalContent = this.dom.modalContent;

      while (modalContent.childNodes.length) {
        node.appendChild(modalContent.childNodes[0]);
      }
    }
  }, {
    key: 'closeKeyHandler',
    value: function closeKeyHandler(e) {
      var closeKeys = this.settings.closeKeys;

      if (isPopulatedArray(closeKeys) && closeKeys.indexOf(e.which) > -1 && this.isOpen === true) {
        e.preventDefault();
        this.close(e);
      }
    }
  }, {
    key: 'outsideClickHandler',
    value: function outsideClickHandler(e) {
      var clickOutside = this.settings.clickOutside;
      var modalInner = this.dom.modalInner;

      if (clickOutside) {
        var node = e.target;
        while (node && node !== document.body) {
          if (node === modalInner) {
            return;
          }
          node = node.parentNode;
        }
        this.close(e);
      }
    }
  }, {
    key: 'delegateOpen',
    value: function delegateOpen(e) {
      var open = this.settings.open;

      var matchedNode = matches(e, open);
      if (matchedNode) {
        e.preventDefault();
        this.open(matchedNode, e);
      }
    }
  }, {
    key: 'delegateClose',
    value: function delegateClose(e) {
      var close = this.settings.close;

      if (matches(e, close)) {
        e.preventDefault();
        this.close(e);
      }
    }
  }, {
    key: 'listen',
    value: function listen() {
      if (this.isListening) {
        this.unlisten();
      }
      var modal = this.dom.modal;
      var transitionEnd = this.settings.transitionEnd;

      if (!this.isListening) {
        modal.addEventListener(transitionEnd, this.closeTransitionHandler);
        modal.addEventListener('click', this.outsideClickHandler, false);
        document.addEventListener('keydown', this.closeKeyHandler, false);
        document.addEventListener('click', this.delegateOpen, false);
        document.addEventListener('click', this.delegateClose, false);
        this.isListening = true;
      } else {
        throwError('Event listeners already applied.');
      }
    }
  }, {
    key: 'unlisten',
    value: function unlisten() {
      var modal = this.dom.modal;
      var transitionEnd = this.settings.transitionEnd;

      modal.removeEventListener('click', this.outsideClickHandler);
      modal.removeEventListener(transitionEnd, this.closeTransitionHandler);
      document.removeEventListener('keydown', this.closeKeyHandler);
      document.removeEventListener('click', this.delegateOpen);
      document.removeEventListener('click', this.delegateClose);
      this.isListening = false;
    }
  }, {
    key: 'respond',
    value: function respond(response, settings) {
      var useSettings = this.settings;
      if (settings) {
        useSettings = Object.assign(useSettings, settings);
      }
      this.close().then(function () {
        window.tags.page_event(useSettings.url, response.name);
        var name = response.name;
        var on_response = useSettings['on' + name];
        if (on_response) {
          on_response(response);
        } else if (useSettings.onResponse) {
          useSettings.onResponse(response);
        }
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.isListening) {
        this.close();
        this.unlisten();
      } else {
        throwError('Event listeners already removed.');
      }
    }
  }], [{
    key: 'getInstance',
    value: function getInstance() {
      return window.EviteModal || new ModalBase();
    }
  }]);

  return ModalBase;
}();

exports.default = ModalBase;

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = retentionBank;

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = mobx;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(59),
    overRest = __webpack_require__(106),
    setToString = __webpack_require__(107);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 76:
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(112),
    isArguments = __webpack_require__(113),
    isArray = __webpack_require__(78),
    isBuffer = __webpack_require__(115),
    isIndex = __webpack_require__(61),
    isTypedArray = __webpack_require__(117);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 79:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

/*! store2 - v2.5.1 - 2017-03-28
* Copyright (c) 2017 Nathan Bubna; Licensed ,  */
;(function(window, define) {
    var _ = {
        version: "2.5.1",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    o[p] = api[p];
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (typeof data === "function"){ return store.transact(key, data, overwrite); }// fn=data, alt=overwrite
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_safariPrivate_';
                area.setItem(testKey, 'sucks');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.inherit(_.storageAPI, { items: {}, name: 'fake' });
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, noSession) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!noSession){ store.area('session', _.areas.session); }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, and) {
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, and || this.get(key)) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return and || this;
            },
            keys: function() {
                return this.each(function(k, list){ list.push(k); }, []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key));
                return s !== null ? _.parse(s) : alt || s;// support alt for easy default mgmt
            },
            getAll: function() {
                return this.each(function(k, all){ all[k] = this.get(k); }, {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt),
                    ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            remove: function(key) {
                var d = this.get(key);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.list){ this.removeItem(k); } },
            toString: function(){ return this.length+' items in '+this.name+'Storage'; }
        }// end _.storageAPI
    };

    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());

    if (typeof define === 'function' && define.amd !== undefined) {
        define('store2', [], function () {
            return store;
        });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = store;
    } else {
        // expose the primary store fn to the global object and save conflicts
        if (window.store){ _.conflict = window.store; }
        window.store = store;
    }

})(this, this.define);


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(98),
    baseAssignValue = __webpack_require__(56);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(56),
    eq = __webpack_require__(48);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(100),
    getValue = __webpack_require__(104);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ })

/******/ });


// WEBPACK FOOTER //
// site-wide-global.js